{
  "id": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
  "createTime": "2025-12-05T13:42:11.639+00:00",
  "updateTime": "2025-12-05T13:42:11.639+00:00",
  "isDeleted": "0",
  "orderId": "af12a7b980f2a12e563e5109dfd19158",
  "workflowTemplateId": "179a3956d8b54a50b9c4b6a722a2f99f",
  "workflowName": "BRCGS Order Timeline",
  "steps": [
    {
      "id": "d34e5d09-645a-4624-a0ba-add378fa06c2",
      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
      "updateBy": "C0F587F29CC17AE748257F33001B4901",
      "createTime": "2025-12-05T13:42:11.644+00:00",
      "updateTime": "2025-12-05T14:31:42.876+00:00",
      "isDeleted": "0",
      "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
      "workflowStepTemplateId": "f47ac10b-58cc-4372-a567-0e02b2c3d479",
      "nextStepId": "bbbd67a1-840c-4723-a473-256dbf5097ad",
      "stepCode": "ORDER_VALIDATION",
      "stepName": "Order validation",
      "stepDescription": "Order validation",
      "stepOrder": 1,
      "isParallel": false,
      "status": "2",
      "steps": [
        {
          "id": "1d04fabb-a70d-410d-a1a2-7ac0d8f51e8a",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "C0F587F29CC17AE748257F33001B4901",
          "createTime": "2025-12-05T13:42:11.653+00:00",
          "updateTime": "2025-12-05T13:51:54.378+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430c8",
          "parentStepId": "d34e5d09-645a-4624-a0ba-add378fa06c2",
          "nextStepId": "22b7c0a2-7064-47b8-a2a6-b925bbaf76f9",
          "stepCode": "AUDIT_REQUESTED",
          "stepName": "Audit requested",
          "stepDescription": "Audit requested",
          "stepOrder": 1,
          "isParallel": false,
          "status": "2",
          "actions": [],
          "configs": [],
          "createByName": "binesh.brcgs",
          "updateByName": "Binesh Narayanan"
        },
        {
          "id": "22b7c0a2-7064-47b8-a2a6-b925bbaf76f9",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "C0F587F29CC17AE748257F33001B4901",
          "createTime": "2025-12-05T13:42:11.655+00:00",
          "updateTime": "2025-12-05T14:17:32.168+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430c9",
          "parentStepId": "d34e5d09-645a-4624-a0ba-add378fa06c2",
          "nextStepId": "fa8fb22e-b532-4ce8-8283-a18394872127",
          "stepCode": "ORDER_REVIEW",
          "stepName": "Order review",
          "stepDescription": "Order review",
          "stepOrder": 2,
          "isParallel": false,
          "status": "2",
          "steps": [
            {
              "id": "7b455ac1-870b-4ddc-b2b9-dfba2e50873f",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "C0F587F29CC17AE748257F33001B4901",
              "createTime": "2025-12-05T13:42:11.657+00:00",
              "updateTime": "2025-12-05T14:17:26.962+00:00",
              "isDeleted": "0",
              "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
              "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430ca",
              "parentStepId": "22b7c0a2-7064-47b8-a2a6-b925bbaf76f9",
              "nextStepId": "8e4e0580-5d82-4ce9-bad6-731b6e4c2cb4",
              "stepCode": "AUDIT_SCOPE",
              "stepName": "Review and validate the audit details",
              "stepDescription": "Review and validate the audit details",
              "stepOrder": 1,
              "isParallel": false,
              "status": "2",
              "actions": [
                {
                  "id": "49ca86fc-2605-491f-be27-7a0c70884823",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.660+00:00",
                  "updateTime": "2025-12-05T13:42:11.660+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepStateId": "7b455ac1-870b-4ddc-b2b9-dfba2e50873f",
                  "workflowStepActionId": "7f8e9d0c-1b2a-3456-7890-1234567890ab",
                  "actionCode": "VIEW_DETAILS",
                  "actionName": "Review and validate",
                  "actionDescription": "Review and validate",
                  "actionType": "BUTTON",
                  "actionOrder": 1,
                  "isRequired": true,
                  "isParallel": false,
                  "status": "0",
                  "configs": [
                    {
                      "id": "9584271b-8acd-453b-9ee1-5aae20f442d4",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.663+00:00",
                      "updateTime": "2025-12-05T13:42:11.663+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "49ca86fc-2605-491f-be27-7a0c70884823",
                      "configKey": "DONE",
                      "configValue": "{\"status\":\"2\",\"name\":\"Review and validate\",\"icon\":\"MENU\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "63b619bd-dfe0-4455-8e24-1f37a1342930",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.666+00:00",
                      "updateTime": "2025-12-05T13:42:11.666+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "49ca86fc-2605-491f-be27-7a0c70884823",
                      "configKey": "IN_PROGRESS",
                      "configValue": "{\"status\":\"1\",\"name\":\"Review and validate\",\"icon\":\"MENU\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "dce576da-7827-4674-8627-b65e7dee9a9b",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.667+00:00",
                      "updateTime": "2025-12-05T13:42:11.667+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "49ca86fc-2605-491f-be27-7a0c70884823",
                      "configKey": "TODO",
                      "configValue": "{\"status\":\"0\",\"name\":\"Review and validate\",\"icon\":\"MENU\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "3eaef1b7-09de-4183-a058-3a353826afcb",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.669+00:00",
                      "updateTime": "2025-12-05T13:42:11.669+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "49ca86fc-2605-491f-be27-7a0c70884823",
                      "configKey": "navigate_to",
                      "configValue": "audit_scope",
                      "configType": "string"
                    }
                  ]
                }
              ],
              "configs": [],
              "createByName": "binesh.brcgs",
              "updateByName": "Binesh Narayanan"
            },
            {
              "id": "8e4e0580-5d82-4ce9-bad6-731b6e4c2cb4",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "C0F587F29CC17AE748257F33001B4901",
              "createTime": "2025-12-05T13:42:11.671+00:00",
              "updateTime": "2025-12-05T14:17:32.316+00:00",
              "isDeleted": "0",
              "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
              "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430cb",
              "parentStepId": "22b7c0a2-7064-47b8-a2a6-b925bbaf76f9",
              "stepCode": "AUDIT_DAYS",
              "stepName": "Validate audit days:",
              "stepDescription": "Validate audit days:",
              "stepOrder": 2,
              "isParallel": false,
              "status": "2",
              "actions": [
                {
                  "id": "1f3911a8-1137-4e66-a87c-e6be03d68f52",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.673+00:00",
                  "updateTime": "2025-12-05T13:42:11.673+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepStateId": "8e4e0580-5d82-4ce9-bad6-731b6e4c2cb4",
                  "workflowStepActionId": "8e9f0a1b-2c3d-4567-8901-2345678901bc",
                  "actionCode": "EDIT",
                  "actionName": "Edit",
                  "actionDescription": "Edit",
                  "actionType": "BUTTON",
                  "actionOrder": 1,
                  "isRequired": true,
                  "isParallel": false,
                  "status": "0",
                  "configs": [
                    {
                      "id": "0ab09f12-08f7-49a0-abdc-4d089f38e616",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.675+00:00",
                      "updateTime": "2025-12-05T13:42:11.675+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "1f3911a8-1137-4e66-a87c-e6be03d68f52",
                      "configKey": "DONE",
                      "configValue": "{\"status\":\"2\",\"name\":\"Edit\",\"icon\":\"EDIT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "2cc5f47b-b016-4db6-a025-4db4eea3f57f",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.677+00:00",
                      "updateTime": "2025-12-05T13:42:11.677+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "1f3911a8-1137-4e66-a87c-e6be03d68f52",
                      "configKey": "IN_PROGRESS",
                      "configValue": "{\"status\":\"1\",\"name\":\"Edit\",\"icon\":\"EDIT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "71681512-ba14-4831-8f4d-c4cf46cca167",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.679+00:00",
                      "updateTime": "2025-12-05T13:42:11.679+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "1f3911a8-1137-4e66-a87c-e6be03d68f52",
                      "configKey": "TODO",
                      "configValue": "{\"status\":\"0\",\"name\":\"Edit\",\"icon\":\"EDIT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "5c87ebc9-b7d0-4ca8-a8d2-20e1b067cb38",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.681+00:00",
                      "updateTime": "2025-12-05T13:42:11.681+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "1f3911a8-1137-4e66-a87c-e6be03d68f52",
                      "configKey": "editable_fields",
                      "configValue": "audit_days",
                      "configType": "string"
                    }
                  ]
                },
                {
                  "id": "81b4ccd9-7df3-4887-8e85-9ee265b6da4c",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.683+00:00",
                  "updateTime": "2025-12-05T13:42:11.683+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepStateId": "8e4e0580-5d82-4ce9-bad6-731b6e4c2cb4",
                  "workflowStepActionId": "9f0a1b2c-3d4e-5678-9012-3456789012cd",
                  "actionCode": "VALIDATE",
                  "actionName": "Validate",
                  "actionDescription": "Validate",
                  "actionType": "BUTTON",
                  "actionOrder": 2,
                  "isRequired": true,
                  "isParallel": false,
                  "status": "0",
                  "configs": [
                    {
                      "id": "44be19b9-b256-42a7-8515-7d9886f05b9d",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.685+00:00",
                      "updateTime": "2025-12-05T13:42:11.685+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "81b4ccd9-7df3-4887-8e85-9ee265b6da4c",
                      "configKey": "DONE",
                      "configValue": "{\"status\":\"2\",\"name\":\"Validate\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "1cea3293-6434-48f5-9402-9f82321b53dd",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.687+00:00",
                      "updateTime": "2025-12-05T13:42:11.687+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "81b4ccd9-7df3-4887-8e85-9ee265b6da4c",
                      "configKey": "IN_PROGRESS",
                      "configValue": "{\"status\":\"1\",\"name\":\"Validate\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "ef8a31b9-3604-462f-ac05-f952f237a646",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.689+00:00",
                      "updateTime": "2025-12-05T13:42:11.689+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "81b4ccd9-7df3-4887-8e85-9ee265b6da4c",
                      "configKey": "TODO",
                      "configValue": "{\"status\":\"0\",\"name\":\"Validate\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "b4c8956e-2003-4989-8c59-c2e3221cae49",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.691+00:00",
                      "updateTime": "2025-12-05T13:42:11.691+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "81b4ccd9-7df3-4887-8e85-9ee265b6da4c",
                      "configKey": "validation_rules",
                      "configValue": "min_value:0.5,max_value:10",
                      "configType": "string"
                    }
                  ]
                }
              ],
              "configs": [],
              "createByName": "binesh.brcgs",
              "updateByName": "Binesh Narayanan"
            }
          ],
          "actions": [],
          "configs": [],
          "createByName": "binesh.brcgs",
          "updateByName": "Binesh Narayanan"
        },
        {
          "id": "fa8fb22e-b532-4ce8-8283-a18394872127",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "C0F587F29CC17AE748257F33001B4901",
          "createTime": "2025-12-05T13:42:11.692+00:00",
          "updateTime": "2025-12-05T14:17:35.830+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430cc",
          "parentStepId": "d34e5d09-645a-4624-a0ba-add378fa06c2",
          "nextStepId": "908616d7-88cf-4d2c-a1fe-253a21956030",
          "stepCode": "ASSIGN_TECH_MANAGER_FOR_VALIDATION",
          "stepName": "Technical manager assignment",
          "stepDescription": "Technical manager assignment",
          "stepOrder": 3,
          "isParallel": false,
          "status": "2",
          "actions": [
            {
              "id": "875a2e3b-a56a-4838-9e32-481dae765d35",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:11.694+00:00",
              "updateTime": "2025-12-05T13:42:11.694+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "fa8fb22e-b532-4ce8-8283-a18394872127",
              "workflowStepActionId": "a0b1c2d3-4e5f-6789-0123-4567890123de",
              "actionCode": "ASSIGN_TECH_MANAGER",
              "actionName": "Assign",
              "actionDescription": "Assign",
              "actionType": "BUTTON",
              "actionOrder": 1,
              "isRequired": true,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "baee7761-8414-4a90-bc45-fdf364323ddb",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.697+00:00",
                  "updateTime": "2025-12-05T13:42:11.697+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "875a2e3b-a56a-4838-9e32-481dae765d35",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"technicalManager\",\"isActionNameDynamic\":true,\"icon\":\"EDIT\",\"iconPosition\":\"right\",\"shouldDisplayActions\":true,\"displayMode\":\"user_assignment\"}",
                  "configType": "JSON"
                },
                {
                  "id": "cc0c6256-7804-4beb-af78-2412a53ea9cf",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.699+00:00",
                  "updateTime": "2025-12-05T13:42:11.699+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "875a2e3b-a56a-4838-9e32-481dae765d35",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Assign\",\"icon\":\"EDIT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "0ed073c0-e58d-4483-a1cb-fcd4f6a1f784",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.701+00:00",
                  "updateTime": "2025-12-05T13:42:11.701+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "875a2e3b-a56a-4838-9e32-481dae765d35",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Assign\",\"icon\":\"ADD_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "0960808d-1ffd-4207-bfba-7b15a9bd766a",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.702+00:00",
                  "updateTime": "2025-12-05T13:42:11.702+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "875a2e3b-a56a-4838-9e32-481dae765d35",
                  "configKey": "assignee_role",
                  "configValue": "tech_manager",
                  "configType": "string"
                }
              ]
            }
          ],
          "configs": [],
          "createByName": "binesh.brcgs",
          "updateByName": "Binesh Narayanan"
        },
        {
          "id": "908616d7-88cf-4d2c-a1fe-253a21956030",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "C0F587F29CC17AE748257F33001B4901",
          "createTime": "2025-12-05T13:42:11.704+00:00",
          "updateTime": "2025-12-05T14:27:54.392+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430cd",
          "parentStepId": "d34e5d09-645a-4624-a0ba-add378fa06c2",
          "nextStepId": "1048232d-02c0-4d39-ac7a-1049963b95c1",
          "stepCode": "TECH_MANAGER_REVIEW",
          "stepName": "Technical manager validation",
          "stepDescription": "Technical manager validation",
          "stepOrder": 4,
          "isParallel": false,
          "status": "2",
          "actions": [
            {
              "id": "ba49b051-7101-4877-8a00-c071c7371463",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:11.708+00:00",
              "updateTime": "2025-12-05T13:42:11.708+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "908616d7-88cf-4d2c-a1fe-253a21956030",
              "workflowStepActionId": "b1c2d3e4-5f6a-7890-1234-5678901234ef",
              "actionCode": "VALIDATE_TECH_MANAGER",
              "actionName": "Review and validate",
              "actionDescription": "Review and validate",
              "actionType": "BUTTON",
              "actionOrder": 1,
              "isRequired": true,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "fc40b3bf-07db-4dad-aab8-0bf5b7990eed",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.710+00:00",
                  "updateTime": "2025-12-05T13:42:11.710+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "ba49b051-7101-4877-8a00-c071c7371463",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"Review and validate\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "afb0ccc6-a948-4bc5-be89-d98f6c6b6ef7",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.712+00:00",
                  "updateTime": "2025-12-05T13:42:11.712+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "ba49b051-7101-4877-8a00-c071c7371463",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Review and validate\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "d62b61c8-eb1d-4477-8691-997bc5a87816",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.714+00:00",
                  "updateTime": "2025-12-05T13:42:11.714+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "ba49b051-7101-4877-8a00-c071c7371463",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Review and validate\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                }
              ]
            }
          ],
          "configs": [
            {
              "id": "98748ac5-a415-4597-9948-9d7701059b7f",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:11.706+00:00",
              "updateTime": "2025-12-05T13:42:11.706+00:00",
              "isDeleted": "0",
              "orderWorkflowStepId": "908616d7-88cf-4d2c-a1fe-253a21956030",
              "configKey": "permissions",
              "configValue": "{\"Admin\":\"edit\",\"Auditor\":\"none\",\"Coordination\":\"readonly\",\"Coordination Manager\":\"readonly\",\"Finance\":\"readonly\",\"Quality\":\"edit\",\"Quality manager\":\"edit\",\"Sales\":\"readonly\",\"Sales Manager\":\"readonly\",\"Technical Reviewer\":\"none\"}",
              "configType": "JSON"
            }
          ],
          "createByName": "binesh.brcgs",
          "updateByName": "Binesh Narayanan"
        },
        {
          "id": "1048232d-02c0-4d39-ac7a-1049963b95c1",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "C0F587F29CC17AE748257F33001B4901",
          "createTime": "2025-12-05T13:42:11.716+00:00",
          "updateTime": "2025-12-05T14:28:14.235+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430ce",
          "parentStepId": "d34e5d09-645a-4624-a0ba-add378fa06c2",
          "nextStepId": "0ac80999-bd80-42ce-aeb0-57ac378c73c9",
          "stepCode": "ORDER_CHARGE",
          "stepName": "Order charge validation",
          "stepDescription": "Order charge validation",
          "stepOrder": 5,
          "isParallel": false,
          "status": "2",
          "actions": [
            {
              "id": "1eacbe1d-e12a-458f-aab2-721645165e47",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:11.718+00:00",
              "updateTime": "2025-12-05T13:42:11.718+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "1048232d-02c0-4d39-ac7a-1049963b95c1",
              "workflowStepActionId": "d3e4f5a6-7b8c-9012-3456-7890123456a1",
              "actionCode": "VALIDATE_CHARGE",
              "actionName": "Validate",
              "actionDescription": "Validate",
              "actionType": "BUTTON",
              "actionOrder": 1,
              "isRequired": true,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "89b2669b-c7ce-4875-8d23-0bf2450875cf",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.721+00:00",
                  "updateTime": "2025-12-05T13:42:11.721+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "1eacbe1d-e12a-458f-aab2-721645165e47",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"Validate\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "9800362a-04e4-4f28-9473-869d82c8f618",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.723+00:00",
                  "updateTime": "2025-12-05T13:42:11.723+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "1eacbe1d-e12a-458f-aab2-721645165e47",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Validate\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "2e89264d-b56d-4240-a88e-bd4cd7796d98",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.725+00:00",
                  "updateTime": "2025-12-05T13:42:11.725+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "1eacbe1d-e12a-458f-aab2-721645165e47",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Validate\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                }
              ]
            }
          ],
          "configs": [],
          "createByName": "binesh.brcgs",
          "updateByName": "Binesh Narayanan"
        },
        {
          "id": "0ac80999-bd80-42ce-aeb0-57ac378c73c9",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "C0F587F29CC17AE748257F33001B4901",
          "createTime": "2025-12-05T13:42:11.727+00:00",
          "updateTime": "2025-12-05T14:28:14.235+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430cf",
          "parentStepId": "d34e5d09-645a-4624-a0ba-add378fa06c2",
          "nextStepId": "a257f9d8-3844-4e61-a7d3-84172a22e6bb",
          "stepCode": "SALES_DOCUMENTS_GENERATED",
          "stepName": "Sales documents generated",
          "stepDescription": "Sales documents generated",
          "stepOrder": 6,
          "isParallel": false,
          "status": "2",
          "actions": [],
          "configs": [],
          "createByName": "binesh.brcgs",
          "updateByName": "Binesh Narayanan"
        },
        {
          "id": "a257f9d8-3844-4e61-a7d3-84172a22e6bb",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "C0F587F29CC17AE748257F33001B4901",
          "createTime": "2025-12-05T13:42:11.729+00:00",
          "updateTime": "2025-12-05T14:31:00.928+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430d0",
          "parentStepId": "d34e5d09-645a-4624-a0ba-add378fa06c2",
          "nextStepId": "0ba45289-746d-4285-a9cc-84c27f09621a",
          "stepCode": "SALES_DOCUMENTS",
          "stepName": "Sales documents",
          "stepDescription": "Sales documents",
          "stepOrder": 7,
          "isParallel": false,
          "status": "2",
          "steps": [
            {
              "id": "ebbc0ebf-b51e-4591-9678-7c1c330dabf1",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "C0F587F29CC17AE748257F33001B4901",
              "createTime": "2025-12-05T13:42:11.732+00:00",
              "updateTime": "2025-12-05T14:30:57.059+00:00",
              "isDeleted": "0",
              "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
              "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430d1",
              "parentStepId": "a257f9d8-3844-4e61-a7d3-84172a22e6bb",
              "nextStepId": "d44b28f8-995e-4ddd-85eb-7e8f4fce6c27",
              "stepCode": "SALES_DOCUMENTS_REVIEW_SEND_TO_CLIENT",
              "stepName": "Review sales documents and send them to client",
              "stepDescription": "Review sales documents and send them to client",
              "stepOrder": 1,
              "isParallel": false,
              "status": "2",
              "actions": [
                {
                  "id": "74ae1e08-130e-4f34-99be-bcd5e298029c",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.733+00:00",
                  "updateTime": "2025-12-05T13:42:11.733+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepStateId": "ebbc0ebf-b51e-4591-9678-7c1c330dabf1",
                  "workflowStepActionId": "e4f5a6b7-8c9d-0123-4567-8901234567b2",
                  "actionCode": "SEND_SALES_DOCS",
                  "actionName": "Send",
                  "actionDescription": "Send",
                  "actionType": "BUTTON",
                  "actionOrder": 1,
                  "isRequired": true,
                  "isParallel": false,
                  "status": "0",
                  "configs": [
                    {
                      "id": "fb709d43-49c2-4729-8c76-0819b8fe69b5",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.736+00:00",
                      "updateTime": "2025-12-05T13:42:11.736+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "74ae1e08-130e-4f34-99be-bcd5e298029c",
                      "configKey": "DONE",
                      "configValue": "{\"status\":\"2\",\"name\":\"Resend\",\"icon\":\"EMAIL\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "d85a4540-c9f0-4dd9-a034-3f78e666a21e",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.738+00:00",
                      "updateTime": "2025-12-05T13:42:11.738+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "74ae1e08-130e-4f34-99be-bcd5e298029c",
                      "configKey": "IN_PROGRESS",
                      "configValue": "{\"status\":\"1\",\"name\":\"Send\",\"icon\":\"EMAIL\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "170d1dea-b666-4601-9b52-92461b7a3e61",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.739+00:00",
                      "updateTime": "2025-12-05T13:42:11.739+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "74ae1e08-130e-4f34-99be-bcd5e298029c",
                      "configKey": "TODO",
                      "configValue": "{\"status\":\"0\",\"name\":\"Send\",\"icon\":\"EMAIL\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "0d588f3b-0d08-431a-97f8-1c3efa352104",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.741+00:00",
                      "updateTime": "2025-12-05T13:42:11.741+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "74ae1e08-130e-4f34-99be-bcd5e298029c",
                      "configKey": "completed_state",
                      "configValue": "hide",
                      "configType": "string"
                    },
                    {
                      "id": "99e490dd-ea00-450a-a172-85aa545f2bad",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.743+00:00",
                      "updateTime": "2025-12-05T13:42:11.743+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "74ae1e08-130e-4f34-99be-bcd5e298029c",
                      "configKey": "pending_state",
                      "configValue": "hide",
                      "configType": "string"
                    }
                  ]
                }
              ],
              "configs": [],
              "createByName": "binesh.brcgs",
              "updateByName": "Binesh Narayanan"
            },
            {
              "id": "d44b28f8-995e-4ddd-85eb-7e8f4fce6c27",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "C0F587F29CC17AE748257F33001B4901",
              "createTime": "2025-12-05T13:42:11.745+00:00",
              "updateTime": "2025-12-05T14:31:00.557+00:00",
              "isDeleted": "0",
              "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
              "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430d2",
              "parentStepId": "a257f9d8-3844-4e61-a7d3-84172a22e6bb",
              "stepCode": "SALES_DOCUMENTS_CONFIRM_CLIENT_ACCEPTANCE",
              "stepName": "Confirm client acceptance",
              "stepDescription": "Confirm client acceptance",
              "stepOrder": 2,
              "isParallel": false,
              "status": "2",
              "actions": [
                {
                  "id": "91ecb222-026d-45ac-a2a8-ff7319c16643",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.747+00:00",
                  "updateTime": "2025-12-05T13:42:11.747+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepStateId": "d44b28f8-995e-4ddd-85eb-7e8f4fce6c27",
                  "workflowStepActionId": "f5a6b7c8-9d0e-1234-5678-9012345678c3",
                  "actionCode": "CONFIRM_SALES_DOCS_SIGNED",
                  "actionName": "Confirm",
                  "actionDescription": "Confirm",
                  "actionType": "BUTTON",
                  "actionOrder": 1,
                  "isRequired": true,
                  "isParallel": false,
                  "status": "0",
                  "configs": [
                    {
                      "id": "ec811018-7bf3-447c-a4d9-797129cf82bd",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.749+00:00",
                      "updateTime": "2025-12-05T13:42:11.749+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "91ecb222-026d-45ac-a2a8-ff7319c16643",
                      "configKey": "DONE",
                      "configValue": "{\"status\":\"2\",\"name\":\"Confirm\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "19c0682c-ed5e-434d-8eab-e88a9255329b",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.751+00:00",
                      "updateTime": "2025-12-05T13:42:11.751+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "91ecb222-026d-45ac-a2a8-ff7319c16643",
                      "configKey": "IN_PROGRESS",
                      "configValue": "{\"status\":\"1\",\"name\":\"Confirm\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "c170f0e9-957c-4896-8be5-e3b3139c1859",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.752+00:00",
                      "updateTime": "2025-12-05T13:42:11.752+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "91ecb222-026d-45ac-a2a8-ff7319c16643",
                      "configKey": "TODO",
                      "configValue": "{\"status\":\"0\",\"name\":\"Confirm\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "f9e9564e-b98d-49e9-a08d-d197c96b1352",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.754+00:00",
                      "updateTime": "2025-12-05T13:42:11.754+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "91ecb222-026d-45ac-a2a8-ff7319c16643",
                      "configKey": "completed_state",
                      "configValue": "hide",
                      "configType": "string"
                    },
                    {
                      "id": "cb6f7fe0-fc5b-4cc7-99e9-b1a0a9ba137f",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.756+00:00",
                      "updateTime": "2025-12-05T13:42:11.756+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "91ecb222-026d-45ac-a2a8-ff7319c16643",
                      "configKey": "pending_state",
                      "configValue": "hide",
                      "configType": "string"
                    }
                  ]
                }
              ],
              "configs": [],
              "createByName": "binesh.brcgs",
              "updateByName": "Binesh Narayanan"
            }
          ],
          "actions": [],
          "configs": [],
          "createByName": "binesh.brcgs",
          "updateByName": "Binesh Narayanan"
        },
        {
          "id": "0ba45289-746d-4285-a9cc-84c27f09621a",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "C0F587F29CC17AE748257F33001B4901",
          "createTime": "2025-12-05T13:42:11.758+00:00",
          "updateTime": "2025-12-05T14:31:42.868+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430d3",
          "parentStepId": "d34e5d09-645a-4624-a0ba-add378fa06c2",
          "stepCode": "ASSIGN_SCHEDULER",
          "stepName": "Scheduler assignment",
          "stepDescription": "Scheduler assignment",
          "stepOrder": 8,
          "isParallel": false,
          "status": "2",
          "actions": [
            {
              "id": "7cc73159-88dc-413d-b46a-60a04228a5e7",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:11.760+00:00",
              "updateTime": "2025-12-05T13:42:11.760+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "0ba45289-746d-4285-a9cc-84c27f09621a",
              "workflowStepActionId": "a6b7c8d9-0e1f-2345-6789-0123456789d4",
              "actionCode": "ASSIGN_SCHEDULER",
              "actionName": "Assign",
              "actionDescription": "Assign",
              "actionType": "BUTTON",
              "actionOrder": 1,
              "isRequired": true,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "88cf4c4c-1d7e-4c52-93ea-8f9dea15dd42",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.761+00:00",
                  "updateTime": "2025-12-05T13:42:11.761+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "7cc73159-88dc-413d-b46a-60a04228a5e7",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"scheduler\",\"isActionNameDynamic\":true,\"icon\":\"EDIT\",\"iconPosition\":\"right\",\"shouldDisplayActions\":true,\"displayMode\":\"user_assignment\"}",
                  "configType": "JSON"
                },
                {
                  "id": "16d26d7e-0fea-4eff-ad6d-dc962532a30c",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.763+00:00",
                  "updateTime": "2025-12-05T13:42:11.763+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "7cc73159-88dc-413d-b46a-60a04228a5e7",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Assign\",\"icon\":\"EDIT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "33ae1c9e-6e50-41d4-9b86-9854020f729b",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.765+00:00",
                  "updateTime": "2025-12-05T13:42:11.765+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "7cc73159-88dc-413d-b46a-60a04228a5e7",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Assign\",\"icon\":\"ADD_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                }
              ]
            }
          ],
          "configs": [],
          "createByName": "binesh.brcgs",
          "updateByName": "Binesh Narayanan"
        }
      ],
      "actions": [],
      "configs": [
        {
          "id": "20780a35-6e8b-4d17-bda6-e12f2c252ada",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
          "createTime": "2025-12-05T13:42:11.648+00:00",
          "updateTime": "2025-12-05T13:42:11.648+00:00",
          "isDeleted": "0",
          "orderWorkflowStepId": "d34e5d09-645a-4624-a0ba-add378fa06c2",
          "configKey": "permissions",
          "configValue": "{\"Admin\":\"edit\",\"Auditor\":\"none\",\"Coordination\":\"edit\",\"Coordination Manager\":\"edit\",\"Decision Maker\":\"edit\",\"Finance\":\"readonly\",\"Operations Manager\":\"readonly\",\"Process reviewer\":\"readonly\",\"Quality\":\"edit\",\"Quality manager\":\"edit\",\"Sales\":\"edit\",\"Sales Manager\":\"edit\",\"Scheduler\":\"readonly\",\"Technical Manager\":\"edit\",\"Technical Reviewer\":\"none\"}",
          "configType": "JSON"
        }
      ]
    },
    {
      "id": "bbbd67a1-840c-4723-a473-256dbf5097ad",
      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
      "updateBy": "C0F587F29CC17AE748257F33001B4901",
      "createTime": "2025-12-05T13:42:11.766+00:00",
      "updateTime": "2025-12-05T14:43:42.309+00:00",
      "isDeleted": "0",
      "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
      "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430d4",
      "nextStepId": "af98e2e6-20ea-4098-99b8-a551f9418391",
      "stepCode": "SCHEDULING",
      "stepName": "Scheduling",
      "stepDescription": "Scheduling",
      "stepOrder": 2,
      "isParallel": false,
      "status": "2",
      "steps": [
        {
          "id": "75f20deb-35cd-4b39-8117-2e1f323bbf37",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "C0F587F29CC17AE748257F33001B4901",
          "createTime": "2025-12-05T13:42:11.769+00:00",
          "updateTime": "2025-12-05T14:31:42.878+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430d5",
          "parentStepId": "bbbd67a1-840c-4723-a473-256dbf5097ad",
          "nextStepId": "9c88c006-2fca-48b0-820e-745e9af71a5e",
          "stepCode": "BOOK_ORDER_REQUESTED_AND_VALIDATED",
          "stepName": "Order validated",
          "stepDescription": "Order validated",
          "stepOrder": 1,
          "isParallel": false,
          "status": "2",
          "actions": [],
          "configs": [],
          "createByName": "binesh.brcgs",
          "updateByName": "Binesh Narayanan"
        },
        {
          "id": "9c88c006-2fca-48b0-820e-745e9af71a5e",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "C0F587F29CC17AE748257F33001B4901",
          "createTime": "2025-12-05T13:42:11.771+00:00",
          "updateTime": "2025-12-05T14:34:48.141+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430d6",
          "parentStepId": "bbbd67a1-840c-4723-a473-256dbf5097ad",
          "nextStepId": "cc28e4e8-aa75-4219-a7e5-a029ccba9d6d",
          "stepCode": "CONTACT_THE_CLIENT",
          "stepName": "First contact with client",
          "stepDescription": "First contact with client",
          "stepOrder": 2,
          "isParallel": false,
          "status": "2",
          "actions": [
            {
              "id": "c95df6b7-863b-4a42-9710-e26daf49821a",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:11.773+00:00",
              "updateTime": "2025-12-05T13:42:11.773+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "9c88c006-2fca-48b0-820e-745e9af71a5e",
              "workflowStepActionId": "b7c8d9e0-1f2a-3456-7890-1234567890e5",
              "actionCode": "REVIEW_SCOPE",
              "actionName": "Review",
              "actionDescription": "Review",
              "actionType": "BUTTON",
              "actionOrder": 1,
              "isRequired": true,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "5d0530ff-6147-47af-99c5-f643f063f232",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.776+00:00",
                  "updateTime": "2025-12-05T13:42:11.776+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "c95df6b7-863b-4a42-9710-e26daf49821a",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"Review\",\"icon\":\"DOCUMENT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "1446ac33-232f-4c52-aecf-c77a6b2fe013",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.778+00:00",
                  "updateTime": "2025-12-05T13:42:11.778+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "c95df6b7-863b-4a42-9710-e26daf49821a",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Review\",\"icon\":\"DOCUMENT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "ec4cd995-7bd8-4257-9e77-84320459f11e",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.780+00:00",
                  "updateTime": "2025-12-05T13:42:11.780+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "c95df6b7-863b-4a42-9710-e26daf49821a",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Review\",\"icon\":\"DOCUMENT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                }
              ]
            },
            {
              "id": "79b07e4e-47a9-4070-9524-740292eb2a6e",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:11.782+00:00",
              "updateTime": "2025-12-05T13:42:11.782+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "9c88c006-2fca-48b0-820e-745e9af71a5e",
              "workflowStepActionId": "c8d9e0f1-2a3b-4567-8901-2345678901f6",
              "actionCode": "CONFIRM_CLIENT_AGREEMENT",
              "actionName": "Confirm contact",
              "actionDescription": "Confirm contact",
              "actionType": "BUTTON",
              "actionOrder": 2,
              "isRequired": true,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "37948935-f2e8-4bef-be79-2ef696c37f79",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.784+00:00",
                  "updateTime": "2025-12-05T13:42:11.784+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "79b07e4e-47a9-4070-9524-740292eb2a6e",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"Confirm contact\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "7e464fb9-1547-4e41-a8f2-40ef936bd8f8",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.786+00:00",
                  "updateTime": "2025-12-05T13:42:11.786+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "79b07e4e-47a9-4070-9524-740292eb2a6e",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Confirm contact\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "801eba7c-b0db-48d7-a996-71bb5ae16b25",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.788+00:00",
                  "updateTime": "2025-12-05T13:42:11.788+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "79b07e4e-47a9-4070-9524-740292eb2a6e",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Confirm contact\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                }
              ]
            }
          ],
          "configs": [],
          "createByName": "binesh.brcgs",
          "updateByName": "Binesh Narayanan"
        },
        {
          "id": "cc28e4e8-aa75-4219-a7e5-a029ccba9d6d",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "C0F587F29CC17AE748257F33001B4901",
          "createTime": "2025-12-05T13:42:11.790+00:00",
          "updateTime": "2025-12-05T14:37:10.516+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430d7",
          "parentStepId": "bbbd67a1-840c-4723-a473-256dbf5097ad",
          "nextStepId": "ff1f7ee9-9dfb-415c-8b57-065a9fb181b8",
          "stepCode": "ASSIGN_AUDITOR",
          "stepName": "Auditor assignment",
          "stepDescription": "Auditor assignment",
          "stepOrder": 3,
          "isParallel": false,
          "status": "2",
          "steps": [
            {
              "id": "5f7e4795-6bf8-40a5-9d0b-d69669862d39",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "C0F587F29CC17AE748257F33001B4901",
              "createTime": "2025-12-05T13:42:11.794+00:00",
              "updateTime": "2025-12-05T14:37:00.173+00:00",
              "isDeleted": "0",
              "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
              "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430d8",
              "parentStepId": "cc28e4e8-aa75-4219-a7e5-a029ccba9d6d",
              "nextStepId": "50e15459-609a-4fd1-8596-2eb4f121e634",
              "stepCode": "ALLOCATE_AUDITOR_ASSIGN_ROLES_WORKLOAD",
              "stepName": "Assign auditor, define roles and workload",
              "stepDescription": "Assign auditor, define roles and workload",
              "stepOrder": 1,
              "isParallel": false,
              "status": "2",
              "actions": [
                {
                  "id": "abb33113-6303-4753-9e8e-24750d58486f",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.796+00:00",
                  "updateTime": "2025-12-05T13:42:11.796+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepStateId": "5f7e4795-6bf8-40a5-9d0b-d69669862d39",
                  "workflowStepActionId": "d9e0f1a2-3b4c-5678-9012-3456789012a7",
                  "actionCode": "AUDIT_DETAILS",
                  "actionName": "Audit details",
                  "actionDescription": "Audit details",
                  "actionType": "BUTTON",
                  "actionOrder": 1,
                  "isRequired": true,
                  "isParallel": false,
                  "status": "0",
                  "configs": [
                    {
                      "id": "a5b4e735-464d-4200-b033-ffb1a3e63867",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.798+00:00",
                      "updateTime": "2025-12-05T13:42:11.798+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "abb33113-6303-4753-9e8e-24750d58486f",
                      "configKey": "DONE",
                      "configValue": "{\"status\":\"2\",\"name\":\"Audit details\",\"icon\":\"DOCUMENT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "38f27b89-a732-4d69-a3c1-475512575a52",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.801+00:00",
                      "updateTime": "2025-12-05T13:42:11.801+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "abb33113-6303-4753-9e8e-24750d58486f",
                      "configKey": "IN_PROGRESS",
                      "configValue": "{\"status\":\"1\",\"name\":\"Audit details\",\"icon\":\"DOCUMENT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "ec6a4f80-813f-42e8-8567-5f9092b48b61",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.802+00:00",
                      "updateTime": "2025-12-05T13:42:11.802+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "abb33113-6303-4753-9e8e-24750d58486f",
                      "configKey": "TODO",
                      "configValue": "{\"status\":\"0\",\"name\":\"Audit details\",\"icon\":\"DOCUMENT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    }
                  ]
                },
                {
                  "id": "02f57254-0505-4798-b86d-d261b6e98cf7",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.804+00:00",
                  "updateTime": "2025-12-05T13:42:11.804+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepStateId": "5f7e4795-6bf8-40a5-9d0b-d69669862d39",
                  "workflowStepActionId": "e0f1a2b3-4c5d-6789-0123-4567890123b8",
                  "actionCode": "ASSIGN",
                  "actionName": "Assign",
                  "actionDescription": "Assign",
                  "actionType": "BUTTON",
                  "actionOrder": 2,
                  "isRequired": true,
                  "isParallel": false,
                  "status": "0",
                  "configs": [
                    {
                      "id": "84f40ca6-4e22-4b9f-a0bd-8531afcd89db",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.806+00:00",
                      "updateTime": "2025-12-05T13:42:11.806+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "02f57254-0505-4798-b86d-d261b6e98cf7",
                      "configKey": "DONE",
                      "configValue": "{\"status\":\"2\",\"name\":\"Edit\",\"isActionNameDynamic\":false,\"icon\":\"EDIT\",\"iconPosition\":\"right\",\"shouldDisplayActions\":true,\"displayMode\":\"user_assignment\"}",
                      "configType": "JSON"
                    },
                    {
                      "id": "cc303e0a-c7aa-4189-a5f3-85959521c7d6",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.808+00:00",
                      "updateTime": "2025-12-05T13:42:11.808+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "02f57254-0505-4798-b86d-d261b6e98cf7",
                      "configKey": "IN_PROGRESS",
                      "configValue": "{\"status\":\"1\",\"name\":\"Assign\",\"icon\":\"EDIT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "8146eadc-bbca-4316-a287-78e1225948e8",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.810+00:00",
                      "updateTime": "2025-12-05T13:42:11.810+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "02f57254-0505-4798-b86d-d261b6e98cf7",
                      "configKey": "TODO",
                      "configValue": "{\"status\":\"0\",\"name\":\"Assign\",\"icon\":\"ADD_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    }
                  ]
                }
              ],
              "configs": [],
              "createByName": "binesh.brcgs",
              "updateByName": "Binesh Narayanan"
            },
            {
              "id": "50e15459-609a-4fd1-8596-2eb4f121e634",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "C0F587F29CC17AE748257F33001B4901",
              "createTime": "2025-12-05T13:42:11.811+00:00",
              "updateTime": "2025-12-05T14:37:02.447+00:00",
              "isDeleted": "0",
              "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
              "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430d9",
              "parentStepId": "cc28e4e8-aa75-4219-a7e5-a029ccba9d6d",
              "nextStepId": "b6f5b09c-69cf-42dd-aeee-3b8a33a283e6",
              "stepCode": "CONFIRM_ABSENCE_CONFLICT_INTERESTS",
              "stepName": "Confirm auditors have no Conflict of Interest",
              "stepDescription": "Confirm auditors have no Conflict of Interest",
              "stepOrder": 2,
              "isParallel": false,
              "status": "2",
              "actions": [
                {
                  "id": "4d733d2f-73c4-4e62-99e0-0d6d47a09f2d",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.813+00:00",
                  "updateTime": "2025-12-05T13:42:11.813+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepStateId": "50e15459-609a-4fd1-8596-2eb4f121e634",
                  "workflowStepActionId": "f1a2b3c4-5d6e-7890-1234-5678901234c9",
                  "actionCode": "SEND_COI_TO_AUDITOR",
                  "actionName": "Confirm",
                  "actionDescription": "Confirm",
                  "actionType": "BUTTON",
                  "actionOrder": 1,
                  "isRequired": true,
                  "isParallel": false,
                  "status": "0",
                  "configs": [
                    {
                      "id": "4d8099f6-a8e6-41bd-b898-e5ceace416d9",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.816+00:00",
                      "updateTime": "2025-12-05T13:42:11.816+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "4d733d2f-73c4-4e62-99e0-0d6d47a09f2d",
                      "configKey": "DONE",
                      "configValue": "{\"status\":\"2\",\"name\":\"Confirm\",\"icon\":\"EMAIL\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "b77aa81d-f780-44c9-8303-36e8f7ec1b2d",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.818+00:00",
                      "updateTime": "2025-12-05T13:42:11.818+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "4d733d2f-73c4-4e62-99e0-0d6d47a09f2d",
                      "configKey": "IN_PROGRESS",
                      "configValue": "{\"status\":\"1\",\"name\":\"Confirm\",\"icon\":\"EMAIL\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "b2bb5f5d-59b0-42ad-95ad-4d6f9e2d9514",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.820+00:00",
                      "updateTime": "2025-12-05T13:42:11.820+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "4d733d2f-73c4-4e62-99e0-0d6d47a09f2d",
                      "configKey": "TODO",
                      "configValue": "{\"status\":\"0\",\"name\":\"Confirm\",\"icon\":\"EMAIL\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    }
                  ]
                }
              ],
              "configs": [],
              "createByName": "binesh.brcgs",
              "updateByName": "Binesh Narayanan"
            },
            {
              "id": "b6f5b09c-69cf-42dd-aeee-3b8a33a283e6",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "C0F587F29CC17AE748257F33001B4901",
              "createTime": "2025-12-05T13:42:11.821+00:00",
              "updateTime": "2025-12-05T14:37:10.525+00:00",
              "isDeleted": "0",
              "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
              "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430da",
              "parentStepId": "cc28e4e8-aa75-4219-a7e5-a029ccba9d6d",
              "stepCode": "NOTIFY_CLIENT",
              "stepName": "Notify client and auditors by email",
              "stepDescription": "Notify client and auditors by email",
              "stepOrder": 3,
              "isParallel": false,
              "status": "2",
              "actions": [
                {
                  "id": "cb8e44e3-812f-48a5-8b6a-2b5fa8a8d29e",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.823+00:00",
                  "updateTime": "2025-12-05T13:42:11.823+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepStateId": "b6f5b09c-69cf-42dd-aeee-3b8a33a283e6",
                  "workflowStepActionId": "a2b3c4d5-6e7f-8901-2345-6789012345da",
                  "actionCode": "SEND",
                  "actionName": "Send",
                  "actionDescription": "Send",
                  "actionType": "BUTTON",
                  "actionOrder": 1,
                  "isRequired": true,
                  "isParallel": false,
                  "status": "0",
                  "configs": [
                    {
                      "id": "8de47ffc-0c02-4076-98db-0459124654d8",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.826+00:00",
                      "updateTime": "2025-12-05T13:42:11.826+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "cb8e44e3-812f-48a5-8b6a-2b5fa8a8d29e",
                      "configKey": "DONE",
                      "configValue": "{\"status\":\"2\",\"name\":\"Send\",\"icon\":\"EMAIL\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "8a53b201-c843-4ea2-b75f-8c7079c20a7b",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.828+00:00",
                      "updateTime": "2025-12-05T13:42:11.828+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "cb8e44e3-812f-48a5-8b6a-2b5fa8a8d29e",
                      "configKey": "IN_PROGRESS",
                      "configValue": "{\"status\":\"1\",\"name\":\"Send\",\"icon\":\"EMAIL\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "aa8c77d1-806b-41d3-b6f3-8cdf87e8f918",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.830+00:00",
                      "updateTime": "2025-12-05T13:42:11.830+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "cb8e44e3-812f-48a5-8b6a-2b5fa8a8d29e",
                      "configKey": "TODO",
                      "configValue": "{\"status\":\"0\",\"name\":\"Send\",\"icon\":\"EMAIL\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    }
                  ]
                }
              ],
              "configs": [],
              "createByName": "binesh.brcgs",
              "updateByName": "Binesh Narayanan"
            }
          ],
          "actions": [
            {
              "id": "21563f90-f4b2-4e40-8f26-e0bef9799693",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:11.831+00:00",
              "updateTime": "2025-12-05T13:42:11.831+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "cc28e4e8-aa75-4219-a7e5-a029ccba9d6d",
              "workflowStepActionId": "91c0e950-2a29-4d8d-9dc5-55e2b55d30f1",
              "actionCode": "UNSCHEDULE_AUDIT",
              "actionName": "Unschedule",
              "actionDescription": "Unschedule audit",
              "actionType": "BUTTON",
              "actionOrder": 3,
              "isRequired": false,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "9736fd34-d33d-4fd6-93fb-70a377a8b19e",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.834+00:00",
                  "updateTime": "2025-12-05T13:42:11.834+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "21563f90-f4b2-4e40-8f26-e0bef9799693",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"Unschedule\",\"icon\":\"CANCEL\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "76e7a7e7-d85c-4aa7-8060-914246c01f0d",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.836+00:00",
                  "updateTime": "2025-12-05T13:42:11.836+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "21563f90-f4b2-4e40-8f26-e0bef9799693",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Unschedule\",\"icon\":\"CANCEL\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "3c8cce47-2125-4263-8c8d-4d5923adc98a",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.837+00:00",
                  "updateTime": "2025-12-05T13:42:11.837+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "21563f90-f4b2-4e40-8f26-e0bef9799693",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Unschedule\",\"icon\":\"CANCEL\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                }
              ]
            }
          ],
          "configs": [],
          "createByName": "binesh.brcgs",
          "updateByName": "Binesh Narayanan"
        },
        {
          "id": "ff1f7ee9-9dfb-415c-8b57-065a9fb181b8",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "C0F587F29CC17AE748257F33001B4901",
          "createTime": "2025-12-05T13:42:11.839+00:00",
          "updateTime": "2025-12-05T14:37:10.670+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430db",
          "parentStepId": "bbbd67a1-840c-4723-a473-256dbf5097ad",
          "nextStepId": "7173bc45-bb10-47db-ac4e-c7c7d86ec6a8",
          "stepCode": "AUDIT_SCHEDULED",
          "stepName": "Audit scheduled",
          "stepDescription": "Audit scheduled",
          "stepOrder": 4,
          "isParallel": false,
          "status": "2",
          "actions": [],
          "configs": [],
          "createByName": "binesh.brcgs",
          "updateByName": "Binesh Narayanan"
        },
        {
          "id": "d57ec89c-e9c8-49d2-adc0-9fb40a2e8953",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "C0F587F29CC17AE748257F33001B4901",
          "createTime": "2025-12-05T13:42:11.841+00:00",
          "updateTime": "2025-12-05T14:43:13.358+00:00",
          "isDeleted": "1",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430dc",
          "parentStepId": "bbbd67a1-840c-4723-a473-256dbf5097ad",
          "nextStepId": "7173bc45-bb10-47db-ac4e-c7c7d86ec6a8",
          "stepCode": "UPLOAD_CPV_DOCUMENT_SCHEDULER",
          "stepName": "Please upload the CPV document",
          "stepDescription": "Please upload the CPV document",
          "stepOrder": 5,
          "isParallel": false,
          "status": "2",
          "actions": [
            {
              "id": "4d56d30e-2725-447c-a4c9-f06773af0e58",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:11.843+00:00",
              "updateTime": "2025-12-05T13:42:11.843+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "d57ec89c-e9c8-49d2-adc0-9fb40a2e8953",
              "workflowStepActionId": "b3c4d5e6-7f8a-9012-3456-7890123456eb",
              "actionCode": "GO_TO_CPV_SCHEDULER",
              "actionName": "Go to CPV",
              "actionDescription": "Go to CPV",
              "actionType": "BUTTON",
              "actionOrder": 1,
              "isRequired": true,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "588b9405-a109-4d4d-8676-63f3a879aa9d",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.845+00:00",
                  "updateTime": "2025-12-05T13:42:11.845+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "4d56d30e-2725-447c-a4c9-f06773af0e58",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"Go to CPV\",\"icon\":\"MENU\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "3b9c4b6c-3125-428e-aeca-8bb3171cdc73",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.847+00:00",
                  "updateTime": "2025-12-05T13:42:11.847+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "4d56d30e-2725-447c-a4c9-f06773af0e58",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Go to CPV\",\"icon\":\"MENU\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "6b7bf522-ab80-43af-9de0-d8e1df1f720c",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.848+00:00",
                  "updateTime": "2025-12-05T13:42:11.848+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "4d56d30e-2725-447c-a4c9-f06773af0e58",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Go to CPV\",\"icon\":\"MENU\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "b1bcd231-a502-4d7a-9f03-fa41edf55868",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.850+00:00",
                  "updateTime": "2025-12-05T13:42:11.850+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "4d56d30e-2725-447c-a4c9-f06773af0e58",
                  "configKey": "completed_state",
                  "configValue": "hide",
                  "configType": "string"
                },
                {
                  "id": "15078e88-6725-4933-b011-7f2689e220fe",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.852+00:00",
                  "updateTime": "2025-12-05T13:42:11.852+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "4d56d30e-2725-447c-a4c9-f06773af0e58",
                  "configKey": "pending_state",
                  "configValue": "hide",
                  "configType": "string"
                }
              ]
            },
            {
              "id": "c1babf04-98cb-4680-9773-a94345d77fa2",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:11.853+00:00",
              "updateTime": "2025-12-05T13:42:11.853+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "d57ec89c-e9c8-49d2-adc0-9fb40a2e8953",
              "workflowStepActionId": "43393ea9-4735-480d-beb2-ce5ad19fa666",
              "actionCode": "CPV_DONE_SCHEDULER",
              "actionName": "Done",
              "actionDescription": "Done",
              "actionType": "BUTTON",
              "actionOrder": 2,
              "isRequired": true,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "7e3b60a7-2570-4bb6-9c60-3b51c289f487",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.856+00:00",
                  "updateTime": "2025-12-05T13:42:11.856+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "c1babf04-98cb-4680-9773-a94345d77fa2",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"Done\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "7177efa4-ad0e-470f-bf89-ee02ffc0af2a",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.858+00:00",
                  "updateTime": "2025-12-05T13:42:11.858+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "c1babf04-98cb-4680-9773-a94345d77fa2",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Done\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "14fdda59-436d-471f-922c-7576fd40ed9d",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.859+00:00",
                  "updateTime": "2025-12-05T13:42:11.859+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "c1babf04-98cb-4680-9773-a94345d77fa2",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Done\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "fba08b40-d648-49ea-9f60-8a614e672706",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.861+00:00",
                  "updateTime": "2025-12-05T13:42:11.861+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "c1babf04-98cb-4680-9773-a94345d77fa2",
                  "configKey": "completed_state",
                  "configValue": "hide",
                  "configType": "string"
                },
                {
                  "id": "e38ebb83-af2f-427b-85df-86fb57d397c4",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.862+00:00",
                  "updateTime": "2025-12-05T13:42:11.862+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "c1babf04-98cb-4680-9773-a94345d77fa2",
                  "configKey": "pending_state",
                  "configValue": "hide",
                  "configType": "string"
                }
              ]
            }
          ],
          "configs": [],
          "createByName": "binesh.brcgs",
          "updateByName": "Binesh Narayanan"
        },
        {
          "id": "7173bc45-bb10-47db-ac4e-c7c7d86ec6a8",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "C0F587F29CC17AE748257F33001B4901",
          "createTime": "2025-12-05T13:42:11.865+00:00",
          "updateTime": "2025-12-05T14:43:38.857+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430dd",
          "parentStepId": "bbbd67a1-840c-4723-a473-256dbf5097ad",
          "nextStepId": "1375dd22-c443-4f7e-9bcb-d75ef9fd7fe9",
          "stepCode": "UPDATE_BRCGS_DIRECTORY",
          "stepName": "Please update the BRCGS Directory",
          "stepDescription": "Please update the BRCGS Directory",
          "stepOrder": 6,
          "isParallel": false,
          "status": "2",
          "actions": [
            {
              "id": "ed0eb7ca-097b-4f6f-a964-d0d5e0ef9278",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:11.867+00:00",
              "updateTime": "2025-12-05T13:42:11.867+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "7173bc45-bb10-47db-ac4e-c7c7d86ec6a8",
              "workflowStepActionId": "c4d5e6f7-8a9b-0123-4567-8901234567fc",
              "actionCode": "UPDATE_BRCGS_DIRECTORY",
              "actionName": "Done",
              "actionDescription": "Done",
              "actionType": "BUTTON",
              "actionOrder": 1,
              "isRequired": true,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "b6f0ac2a-66cf-45f2-b892-0a0d06d56675",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.870+00:00",
                  "updateTime": "2025-12-05T13:42:11.870+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "ed0eb7ca-097b-4f6f-a964-d0d5e0ef9278",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"Done\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "6d233154-92ff-475b-837c-250bdc138804",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.872+00:00",
                  "updateTime": "2025-12-05T13:42:11.872+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "ed0eb7ca-097b-4f6f-a964-d0d5e0ef9278",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Done\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "5b8e7f14-f767-4871-bd0a-5cdf442f5f4d",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.873+00:00",
                  "updateTime": "2025-12-05T13:42:11.873+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "ed0eb7ca-097b-4f6f-a964-d0d5e0ef9278",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Done\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "1e0ba78f-594b-4335-bdbe-2ed650d10d9d",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.875+00:00",
                  "updateTime": "2025-12-05T13:42:11.875+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "ed0eb7ca-097b-4f6f-a964-d0d5e0ef9278",
                  "configKey": "completed_state",
                  "configValue": "hide",
                  "configType": "string"
                }
              ]
            }
          ],
          "configs": [],
          "createByName": "binesh.brcgs",
          "updateByName": "Binesh Narayanan"
        },
        {
          "id": "1375dd22-c443-4f7e-9bcb-d75ef9fd7fe9",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "C0F587F29CC17AE748257F33001B4901",
          "createTime": "2025-12-05T13:42:11.876+00:00",
          "updateTime": "2025-12-05T14:43:41.961+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430de",
          "parentStepId": "bbbd67a1-840c-4723-a473-256dbf5097ad",
          "stepCode": "ASSIGN_PROCESS_REVIEWER",
          "stepName": "Process reviewer assignment",
          "stepDescription": "Process reviewer assignment",
          "stepOrder": 7,
          "isParallel": false,
          "status": "2",
          "actions": [
            {
              "id": "fba9d308-899e-4b49-ac96-d068c0501b40",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:11.879+00:00",
              "updateTime": "2025-12-05T13:42:11.879+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "1375dd22-c443-4f7e-9bcb-d75ef9fd7fe9",
              "workflowStepActionId": "d5e6f7a8-9b0c-1234-5678-9012345678ad",
              "actionCode": "ASSIGN_PROCESS_REVIEWER",
              "actionName": "Assign",
              "actionDescription": "Assign",
              "actionType": "BUTTON",
              "actionOrder": 1,
              "isRequired": true,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "6abc8dc8-03d8-4bfa-89da-0d9074e425bc",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.881+00:00",
                  "updateTime": "2025-12-05T13:42:11.881+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "fba9d308-899e-4b49-ac96-d068c0501b40",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"processReviewer\",\"isActionNameDynamic\":true,\"icon\":\"EDIT\",\"iconPosition\":\"right\",\"shouldDisplayActions\":true,\"displayMode\":\"user_assignment\"}",
                  "configType": "JSON"
                },
                {
                  "id": "8d8b4e20-d1dd-413b-8755-b098aa47cde2",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.883+00:00",
                  "updateTime": "2025-12-05T13:42:11.883+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "fba9d308-899e-4b49-ac96-d068c0501b40",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Assign\",\"icon\":\"EDIT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "b3380b93-5054-490a-a75e-fff04e2e3d2d",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.884+00:00",
                  "updateTime": "2025-12-05T13:42:11.884+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "fba9d308-899e-4b49-ac96-d068c0501b40",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Assign\",\"icon\":\"ADD_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                }
              ]
            }
          ],
          "configs": [],
          "createByName": "binesh.brcgs",
          "updateByName": "Binesh Narayanan"
        }
      ],
      "actions": [],
      "configs": [
        {
          "id": "a7c8afd0-21a0-4145-bdba-89de00d450bb",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
          "createTime": "2025-12-05T13:42:11.768+00:00",
          "updateTime": "2025-12-05T13:42:11.768+00:00",
          "isDeleted": "0",
          "orderWorkflowStepId": "bbbd67a1-840c-4723-a473-256dbf5097ad",
          "configKey": "permissions",
          "configValue": "{\"Admin\":\"edit\",\"Auditor\":\"none\",\"Coordination\":\"edit\",\"Coordination Manager\":\"edit\",\"Finance\":\"readonly\",\"Quality\":\"edit\",\"Quality manager\":\"edit\",\"Sales\":\"readonly\",\"Sales Manager\":\"readonly\",\"Technical Reviewer\":\"none\"}",
          "configType": "JSON"
        }
      ]
    },
    {
      "id": "af98e2e6-20ea-4098-99b8-a551f9418391",
      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
      "updateBy": "C0F587F29CC17AE748257F33001B4901",
      "createTime": "2025-12-05T13:42:11.886+00:00",
      "updateTime": "2025-12-05T15:21:07.770+00:00",
      "isDeleted": "0",
      "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
      "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430df",
      "nextStepId": "eedffdd3-8464-45c5-b421-7fecfef4584c",
      "stepCode": "AUDIT",
      "stepName": "Audit",
      "stepDescription": "Audit",
      "stepOrder": 3,
      "isParallel": false,
      "status": "2",
      "steps": [
        {
          "id": "1253a8c6-486a-4bc3-8768-453670e82f2e",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "C0F587F29CC17AE748257F33001B4901",
          "createTime": "2025-12-05T13:42:11.890+00:00",
          "updateTime": "2025-12-05T14:43:42.461+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430e0",
          "parentStepId": "af98e2e6-20ea-4098-99b8-a551f9418391",
          "nextStepId": "d1d3841b-d86b-483d-bbf8-db742bf5a882",
          "stepCode": "ORDER_SCHEDULED",
          "stepName": "Order scheduled",
          "stepDescription": "Order scheduled",
          "stepOrder": 1,
          "isParallel": false,
          "status": "2",
          "actions": [],
          "configs": [],
          "createByName": "binesh.brcgs",
          "updateByName": "Binesh Narayanan"
        },
        {
          "id": "d1d3841b-d86b-483d-bbf8-db742bf5a882",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "C0F587F29CC17AE748257F33001B4901",
          "createTime": "2025-12-05T13:42:11.892+00:00",
          "updateTime": "2025-12-05T15:08:38.747+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430e1",
          "parentStepId": "af98e2e6-20ea-4098-99b8-a551f9418391",
          "nextStepId": "3c9295a6-56f1-484d-81b1-793fae4384ff",
          "stepCode": "AUDIT_PLAN",
          "stepName": "Audit preparation",
          "stepDescription": "Audit preparation",
          "stepOrder": 2,
          "isParallel": false,
          "status": "2",
          "actions": [
            {
              "id": "514bf307-3326-4a76-a06a-1b6748553225",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:11.893+00:00",
              "updateTime": "2025-12-05T13:42:11.893+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "d1d3841b-d86b-483d-bbf8-db742bf5a882",
              "workflowStepActionId": "3d1ee157-e380-43ae-b3e4-e7aa54098eb0",
              "actionCode": "AUDIT_PREP_DOWNLOAD_ALL",
              "actionName": "Download all",
              "actionDescription": "Download all",
              "actionType": "BUTTON",
              "actionOrder": 1,
              "isRequired": true,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "63881457-a667-4ffa-842a-4b19d87fc94d",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.896+00:00",
                  "updateTime": "2025-12-05T13:42:11.896+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "514bf307-3326-4a76-a06a-1b6748553225",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"Download all\",\"icon\":\"DOWNLOAD_IMPORT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "7aa7f6ce-9412-44a1-ab61-eb910a43d898",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.898+00:00",
                  "updateTime": "2025-12-05T13:42:11.898+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "514bf307-3326-4a76-a06a-1b6748553225",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Download all\",\"icon\":\"DOWNLOAD_IMPORT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "1a8162d5-73c8-4559-81e6-097723545da2",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.899+00:00",
                  "updateTime": "2025-12-05T13:42:11.899+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "514bf307-3326-4a76-a06a-1b6748553225",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Download all\",\"icon\":\"DOWNLOAD_IMPORT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                }
              ]
            },
            {
              "id": "051d060d-5852-4638-b5a4-ad5479d58cfb",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:11.901+00:00",
              "updateTime": "2025-12-05T13:42:11.901+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "d1d3841b-d86b-483d-bbf8-db742bf5a882",
              "workflowStepActionId": "e6f7a8b9-0c1d-2345-6789-0123456789be",
              "actionCode": "AUDIT_PREP_SEND_AUDIT_PLAN",
              "actionName": "Send audit plan",
              "actionDescription": "Send audit plan",
              "actionType": "BUTTON",
              "actionOrder": 2,
              "isRequired": true,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "46b14941-c7a8-4f07-90a8-6947a9ab7c78",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.903+00:00",
                  "updateTime": "2025-12-05T13:42:11.903+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "051d060d-5852-4638-b5a4-ad5479d58cfb",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"Resend audit plan\",\"icon\":\"EMAIL\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "19a6b82e-ff63-45ba-90f0-70b4c776d515",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.905+00:00",
                  "updateTime": "2025-12-05T13:42:11.905+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "051d060d-5852-4638-b5a4-ad5479d58cfb",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Send audit plan\",\"icon\":\"EMAIL\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "61689de9-f8ea-4001-ac01-91b274faf17e",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.906+00:00",
                  "updateTime": "2025-12-05T13:42:11.906+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "051d060d-5852-4638-b5a4-ad5479d58cfb",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Send audit plan\",\"icon\":\"EMAIL\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                }
              ]
            },
            {
              "id": "18d30b4b-d281-4017-8d5b-954cc552c458",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:11.908+00:00",
              "updateTime": "2025-12-05T13:42:11.908+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "d1d3841b-d86b-483d-bbf8-db742bf5a882",
              "workflowStepActionId": "f7a8b9c0-1d2e-3456-7890-1234567890cf",
              "actionCode": "AUDIT_PREP_START_AUDIT",
              "actionName": "Start audit",
              "actionDescription": "Start audit",
              "actionType": "BUTTON",
              "actionOrder": 3,
              "isRequired": true,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "9014629a-36cb-4c35-8b77-4288071b91bd",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.910+00:00",
                  "updateTime": "2025-12-05T13:42:11.910+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "18d30b4b-d281-4017-8d5b-954cc552c458",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"Start audit\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "385a572d-ce47-4de5-8a72-0c95d2856f8b",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.912+00:00",
                  "updateTime": "2025-12-05T13:42:11.912+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "18d30b4b-d281-4017-8d5b-954cc552c458",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Start audit\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "6c808670-58e8-4694-8a11-780c67dbb3c8",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.914+00:00",
                  "updateTime": "2025-12-05T13:42:11.914+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "18d30b4b-d281-4017-8d5b-954cc552c458",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Start audit\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                }
              ]
            }
          ],
          "configs": [],
          "createByName": "binesh.brcgs",
          "updateByName": "Binesh Narayanan"
        },
        {
          "id": "3c9295a6-56f1-484d-81b1-793fae4384ff",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "C0F587F29CC17AE748257F33001B4901",
          "createTime": "2025-12-05T13:42:11.916+00:00",
          "updateTime": "2025-12-05T15:08:38.756+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430e2",
          "parentStepId": "af98e2e6-20ea-4098-99b8-a551f9418391",
          "nextStepId": "5ed5b638-468b-47a8-b2e2-ecd9063947b3",
          "stepCode": "AUDIT_STARTED",
          "stepName": "Audit started",
          "stepDescription": "Audit started",
          "stepOrder": 3,
          "isParallel": false,
          "status": "2",
          "actions": [],
          "configs": [],
          "createByName": "binesh.brcgs",
          "updateByName": "Binesh Narayanan"
        },
        {
          "id": "5ed5b638-468b-47a8-b2e2-ecd9063947b3",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "C0F587F29CC17AE748257F33001B4901",
          "createTime": "2025-12-05T13:42:11.918+00:00",
          "updateTime": "2025-12-05T15:21:07.766+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "ddf97bbb-c302-4f92-87d1-46601edc1d7f",
          "parentStepId": "af98e2e6-20ea-4098-99b8-a551f9418391",
          "stepCode": "AUDIT_RUN",
          "stepName": "Audit",
          "stepDescription": "Audit",
          "stepOrder": 4,
          "isParallel": false,
          "status": "2",
          "steps": [
            {
              "id": "fbd49c5d-42ed-4b6d-bd43-7e2d0a16ff92",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "C0F587F29CC17AE748257F33001B4901",
              "createTime": "2025-12-05T13:42:11.920+00:00",
              "updateTime": "2025-12-05T15:09:03.310+00:00",
              "isDeleted": "0",
              "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
              "workflowStepTemplateId": "741de9c4-044c-49ff-bcaf-802a0ce3a22f",
              "parentStepId": "5ed5b638-468b-47a8-b2e2-ecd9063947b3",
              "nextStepId": "bd5a9865-b644-4753-bc20-c55b68b27151",
              "stepCode": "CONFIRM_CA",
              "stepName": "Confirm CA need and send preliminary summary of NCs",
              "stepDescription": "Confirm CA need and send preliminary summary of NCs",
              "stepOrder": 1,
              "isParallel": false,
              "status": "2",
              "actions": [
                {
                  "id": "ad20c8cf-6ab8-4e46-9568-90d81a68f2cc",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.922+00:00",
                  "updateTime": "2025-12-05T13:42:11.922+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepStateId": "fbd49c5d-42ed-4b6d-bd43-7e2d0a16ff92",
                  "workflowStepActionId": "6b902842-7311-440e-8c90-3fb22422b6fe",
                  "actionCode": "SEND_TO_CLIENT_PROCESS_REVIEWER",
                  "actionName": "Send to client and process reviewer",
                  "actionDescription": "Send to client and process reviewer",
                  "actionType": "BUTTON",
                  "actionOrder": 1,
                  "isRequired": false,
                  "isParallel": false,
                  "status": "0",
                  "configs": [
                    {
                      "id": "022892a3-b02f-49d7-9b92-764b820bd6aa",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.924+00:00",
                      "updateTime": "2025-12-05T13:42:11.924+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "ad20c8cf-6ab8-4e46-9568-90d81a68f2cc",
                      "configKey": "DONE",
                      "configValue": "{\"status\":\"2\",\"name\":\"Send to client and process reviewer\",\"icon\":\"EMAIL\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "518a7e54-2ae6-4d14-aa3b-99cacedd94df",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.927+00:00",
                      "updateTime": "2025-12-05T13:42:11.927+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "ad20c8cf-6ab8-4e46-9568-90d81a68f2cc",
                      "configKey": "IN_PROGRESS",
                      "configValue": "{\"status\":\"1\",\"name\":\"Send to client and process reviewer\",\"icon\":\"EMAIL\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "8e015596-4749-4b01-b8ba-1cb79aee8db6",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.929+00:00",
                      "updateTime": "2025-12-05T13:42:11.929+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "ad20c8cf-6ab8-4e46-9568-90d81a68f2cc",
                      "configKey": "TODO",
                      "configValue": "{\"status\":\"0\",\"name\":\"Send to client and process reviewer\",\"icon\":\"EMAIL\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    }
                  ]
                }
              ],
              "configs": [],
              "createByName": "binesh.brcgs",
              "updateByName": "Binesh Narayanan"
            },
            {
              "id": "bd5a9865-b644-4753-bc20-c55b68b27151",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "C0F587F29CC17AE748257F33001B4901",
              "createTime": "2025-12-05T13:42:11.930+00:00",
              "updateTime": "2025-12-05T15:21:07.761+00:00",
              "isDeleted": "0",
              "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
              "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430e4",
              "parentStepId": "5ed5b638-468b-47a8-b2e2-ecd9063947b3",
              "stepCode": "COMPLETE_AUDIT_PACK",
              "stepName": "Complete audit pack",
              "stepDescription": "Complete audit pack",
              "stepOrder": 2,
              "isParallel": false,
              "status": "2",
              "actions": [
                {
                  "id": "8a442edf-cbe9-441e-89ad-d30a216fc86e",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.932+00:00",
                  "updateTime": "2025-12-05T13:42:11.932+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepStateId": "bd5a9865-b644-4753-bc20-c55b68b27151",
                  "workflowStepActionId": "d9efef46-6a8f-4468-8311-379674ca18cd",
                  "actionCode": "AUDIT_PACK_NOTIFICATION",
                  "actionName": "Notify process reviewer",
                  "actionDescription": "Notify process reviewer",
                  "actionType": "BUTTON",
                  "actionOrder": 1,
                  "isRequired": false,
                  "isParallel": false,
                  "status": "0",
                  "configs": [
                    {
                      "id": "a9bc081d-d0ad-4a7e-86db-a347ef8239fd",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.934+00:00",
                      "updateTime": "2025-12-05T13:42:11.934+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "8a442edf-cbe9-441e-89ad-d30a216fc86e",
                      "configKey": "DONE",
                      "configValue": "{\"status\":\"2\",\"name\":\"Notify process reviewer\",\"icon\":\"EMAIL\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "ae24f495-b227-4b1c-a772-0830cfbf4b16",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.936+00:00",
                      "updateTime": "2025-12-05T13:42:11.936+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "8a442edf-cbe9-441e-89ad-d30a216fc86e",
                      "configKey": "IN_PROGRESS",
                      "configValue": "{\"status\":\"1\",\"name\":\"Notify process reviewer\",\"icon\":\"EMAIL\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "c6e8036b-6ca0-4cc3-800f-cddeed4307ef",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:11.938+00:00",
                      "updateTime": "2025-12-05T13:42:11.938+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "8a442edf-cbe9-441e-89ad-d30a216fc86e",
                      "configKey": "TODO",
                      "configValue": "{\"status\":\"0\",\"name\":\"Notify process reviewer\",\"icon\":\"EMAIL\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    }
                  ]
                }
              ],
              "configs": [],
              "createByName": "binesh.brcgs",
              "updateByName": "Binesh Narayanan"
            }
          ],
          "actions": [],
          "configs": [],
          "createByName": "binesh.brcgs",
          "updateByName": "Binesh Narayanan"
        }
      ],
      "actions": [],
      "configs": [
        {
          "id": "5d19d029-96ca-4873-86fc-f9e95fdb38d7",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
          "createTime": "2025-12-05T13:42:11.888+00:00",
          "updateTime": "2025-12-05T13:42:11.888+00:00",
          "isDeleted": "0",
          "orderWorkflowStepId": "af98e2e6-20ea-4098-99b8-a551f9418391",
          "configKey": "permissions",
          "configValue": "{\"Admin\":\"edit\",\"Auditor\":\"edit\",\"Coordination\":\"edit\",\"Coordination Manager\":\"edit\",\"Finance\":\"readonly\",\"Quality\":\"edit\",\"Quality manager\":\"edit\",\"Sales\":\"readonly\",\"Sales Manager\":\"readonly\",\"Technical Reviewer\":\"edit\"}",
          "configType": "JSON"
        }
      ]
    },
    {
      "id": "eedffdd3-8464-45c5-b421-7fecfef4584c",
      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
      "createTime": "2025-12-05T13:42:11.940+00:00",
      "updateTime": "2025-12-05T13:42:11.940+00:00",
      "isDeleted": "0",
      "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
      "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430e6",
      "nextStepId": "b6a46ebf-13a6-4ba8-92ac-6b03504f6691",
      "stepCode": "CORRECTIVE_ACTIONS",
      "stepName": "Corrective actions",
      "stepDescription": "Corrective actions",
      "stepOrder": 4,
      "isParallel": true,
      "status": "0",
      "steps": [
        {
          "id": "cc1575f8-5de7-46c1-b1eb-139942861f19",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
          "createTime": "2025-12-05T13:42:11.945+00:00",
          "updateTime": "2025-12-05T13:42:11.945+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430e7",
          "parentStepId": "eedffdd3-8464-45c5-b421-7fecfef4584c",
          "nextStepId": "bc8f281d-68d3-4839-b0f9-8cf471c3b998",
          "stepCode": "CORRECTIVE_ACTIONS_NEEDED_FROM_CLIENT",
          "stepName": "Corrective actions needed from client",
          "stepDescription": "Corrective actions needed from client",
          "stepOrder": 1,
          "isParallel": false,
          "status": "0",
          "actions": [],
          "configs": [],
          "createByName": "binesh.brcgs",
          "updateByName": "binesh.brcgs"
        },
        {
          "id": "bc8f281d-68d3-4839-b0f9-8cf471c3b998",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
          "createTime": "2025-12-05T13:42:11.946+00:00",
          "updateTime": "2025-12-05T13:42:11.946+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430e8",
          "parentStepId": "eedffdd3-8464-45c5-b421-7fecfef4584c",
          "nextStepId": "5ea9fa75-ae91-4350-9a48-b20410b4d7d5",
          "stepCode": "CORRECTIVE_ACTIONS_UPLOADED",
          "stepName": "Corrective actions",
          "stepDescription": "Upload documents received by client, fill in the date and confirm all CAs have been received",
          "stepOrder": 2,
          "isParallel": false,
          "status": "0",
          "actions": [
            {
              "id": "83d4e299-1bf3-4c3d-abbb-72ec4d25628a",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:11.948+00:00",
              "updateTime": "2025-12-05T13:42:11.948+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "bc8f281d-68d3-4839-b0f9-8cf471c3b998",
              "workflowStepActionId": "b9c0d1e2-3f4a-5678-9012-3456789012e1",
              "actionCode": "UPLOAD_CORRECTIVE_ACTIONS_FILE",
              "actionName": "Upload file",
              "actionDescription": "Browse or drag & drop your file to upload",
              "actionType": "FILE_UPLOAD",
              "actionOrder": 1,
              "isRequired": true,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "2b47ed1a-1e91-4145-8a90-eee7fad33212",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.951+00:00",
                  "updateTime": "2025-12-05T13:42:11.951+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "83d4e299-1bf3-4c3d-abbb-72ec4d25628a",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"Upload file\",\"icon\":\"UPLOAD\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "8ea177ce-6ce5-49c6-9ed8-9b75cbe6688b",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.954+00:00",
                  "updateTime": "2025-12-05T13:42:11.954+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "83d4e299-1bf3-4c3d-abbb-72ec4d25628a",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Upload file\",\"icon\":\"UPLOAD\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "ace990de-8fcd-47aa-a054-a87cbf20a1ad",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.955+00:00",
                  "updateTime": "2025-12-05T13:42:11.955+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "83d4e299-1bf3-4c3d-abbb-72ec4d25628a",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Upload file\",\"icon\":\"UPLOAD\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                }
              ]
            },
            {
              "id": "ae0bef2a-eab2-419d-94e4-83e990910265",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:11.957+00:00",
              "updateTime": "2025-12-05T13:42:11.957+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "bc8f281d-68d3-4839-b0f9-8cf471c3b998",
              "workflowStepActionId": "E21E6F4E5B8542A2A33F0F24F47D6860",
              "actionCode": "ALL_CA_RECEIVED",
              "actionName": "All CAs received",
              "actionDescription": "All CAs received",
              "actionType": "BUTTON",
              "actionOrder": 1,
              "isRequired": true,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "bd06746e-8c98-4477-a180-71340f99c3de",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.959+00:00",
                  "updateTime": "2025-12-05T13:42:11.959+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "ae0bef2a-eab2-419d-94e4-83e990910265",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"All CAs received\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "1e3f3637-af30-42ff-a186-7542937e6784",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.961+00:00",
                  "updateTime": "2025-12-05T13:42:11.961+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "ae0bef2a-eab2-419d-94e4-83e990910265",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"All CAs received\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "c05d3aeb-afc6-4924-a5bd-254838f9822b",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.963+00:00",
                  "updateTime": "2025-12-05T13:42:11.963+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "ae0bef2a-eab2-419d-94e4-83e990910265",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"All CAs received\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                }
              ]
            },
            {
              "id": "c8ba4fa1-f303-4b14-87ca-1dfc1d1d84e8",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:11.964+00:00",
              "updateTime": "2025-12-05T13:42:11.964+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "bc8f281d-68d3-4839-b0f9-8cf471c3b998",
              "workflowStepActionId": "ebc57663-6aa7-4874-8dc5-0e1979c7d6c9",
              "actionCode": "EDIT_DATE_CA",
              "actionName": "Edit date",
              "actionDescription": "Edit date",
              "actionType": "BUTTON",
              "actionOrder": 2,
              "isRequired": true,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "f0d7ef02-96cb-4675-b82e-f1658f2e4342",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.966+00:00",
                  "updateTime": "2025-12-05T13:42:11.966+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "c8ba4fa1-f303-4b14-87ca-1dfc1d1d84e8",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"Edit date\",\"icon\":\"EDIT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "74322ed8-fede-411f-a851-a1ab0449cea1",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.968+00:00",
                  "updateTime": "2025-12-05T13:42:11.968+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "c8ba4fa1-f303-4b14-87ca-1dfc1d1d84e8",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Edit date\",\"icon\":\"EDIT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "88b56cb0-1f00-4991-9dc7-3e25b3d00f81",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.971+00:00",
                  "updateTime": "2025-12-05T13:42:11.971+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "c8ba4fa1-f303-4b14-87ca-1dfc1d1d84e8",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Edit date\",\"icon\":\"EDIT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                }
              ]
            }
          ],
          "configs": [],
          "createByName": "binesh.brcgs",
          "updateByName": "binesh.brcgs"
        },
        {
          "id": "5ea9fa75-ae91-4350-9a48-b20410b4d7d5",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
          "createTime": "2025-12-05T13:42:11.972+00:00",
          "updateTime": "2025-12-05T13:42:11.972+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430e9",
          "parentStepId": "eedffdd3-8464-45c5-b421-7fecfef4584c",
          "stepCode": "UPLOAD_CLOSING_SUMMARY_NON_CONFORMANCES",
          "stepName": "Closing summary of non-conformances",
          "stepDescription": "Upload the summary, fill in the date and notify the process reviewer",
          "stepOrder": 3,
          "isParallel": false,
          "status": "0",
          "actions": [
            {
              "id": "f10f3773-5dda-4198-abae-62c956866ae6",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:11.974+00:00",
              "updateTime": "2025-12-05T13:42:11.974+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "5ea9fa75-ae91-4350-9a48-b20410b4d7d5",
              "workflowStepActionId": "a47ce770-9738-48f3-a2a9-db62cd67892c",
              "actionCode": "CLOSING_SUMMARY_NOTIFY_PROCESS_REVIEWER",
              "actionName": "Notify process reviewer",
              "actionDescription": "Notify process reviewer",
              "actionType": "BUTTON",
              "actionOrder": 1,
              "isRequired": false,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "3617d45b-6aec-42ee-8b82-15365f243d7f",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.976+00:00",
                  "updateTime": "2025-12-05T13:42:11.976+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "f10f3773-5dda-4198-abae-62c956866ae6",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"Notify process reviewer\",\"icon\":\"EMAIL\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "94f0778d-741b-4435-8936-22b0f5d36f2d",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.978+00:00",
                  "updateTime": "2025-12-05T13:42:11.978+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "f10f3773-5dda-4198-abae-62c956866ae6",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Notify process reviewer\",\"icon\":\"EMAIL\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "324b15df-0390-41eb-8518-606bad0a0625",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.979+00:00",
                  "updateTime": "2025-12-05T13:42:11.979+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "f10f3773-5dda-4198-abae-62c956866ae6",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Notify process reviewer\",\"icon\":\"EMAIL\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                }
              ]
            },
            {
              "id": "4487c0f8-38d6-4181-9ed6-c59d42798c42",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:11.981+00:00",
              "updateTime": "2025-12-05T13:42:11.981+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "5ea9fa75-ae91-4350-9a48-b20410b4d7d5",
              "workflowStepActionId": "1e145790-2540-46c0-bdf1-298130b24fb6",
              "actionCode": "EDIT_DATE_CLOSURE",
              "actionName": "Edit date",
              "actionDescription": "Edit date",
              "actionType": "BUTTON",
              "actionOrder": 2,
              "isRequired": true,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "81fae2da-f128-452e-9542-b6d35e26ae8d",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.982+00:00",
                  "updateTime": "2025-12-05T13:42:11.982+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "4487c0f8-38d6-4181-9ed6-c59d42798c42",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"Edit date\",\"icon\":\"EDIT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "f5c8d3d1-fe46-4e85-8e9e-9881cb96b4d8",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.984+00:00",
                  "updateTime": "2025-12-05T13:42:11.984+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "4487c0f8-38d6-4181-9ed6-c59d42798c42",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Edit date\",\"icon\":\"EDIT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "38efde53-2b74-4a47-833c-ca57792d9be2",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:11.986+00:00",
                  "updateTime": "2025-12-05T13:42:11.986+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "4487c0f8-38d6-4181-9ed6-c59d42798c42",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Edit date\",\"icon\":\"EDIT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                }
              ]
            }
          ],
          "configs": [],
          "createByName": "binesh.brcgs",
          "updateByName": "binesh.brcgs"
        }
      ],
      "actions": [],
      "configs": [
        {
          "id": "d4a525d8-79cb-4572-957d-e451fcaf68de",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
          "createTime": "2025-12-05T13:42:11.943+00:00",
          "updateTime": "2025-12-05T13:42:11.943+00:00",
          "isDeleted": "0",
          "orderWorkflowStepId": "eedffdd3-8464-45c5-b421-7fecfef4584c",
          "configKey": "permissions",
          "configValue": "{\"Admin\":\"edit\",\"Auditor\":\"edit\",\"Coordination\":\"edit\",\"Coordination Manager\":\"edit\",\"Finance\":\"readonly\",\"Quality\":\"edit\",\"Quality manager\":\"edit\",\"Sales\":\"readonly\",\"Sales Manager\":\"readonly\",\"Technical Reviewer\":\"edit\"}",
          "configType": "JSON"
        }
      ]
    },
    {
      "id": "b6a46ebf-13a6-4ba8-92ac-6b03504f6691",
      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
      "updateBy": "C0F587F29CC17AE748257F33001B4901",
      "createTime": "2025-12-05T13:42:11.987+00:00",
      "updateTime": "2025-12-05T15:21:07.774+00:00",
      "isDeleted": "0",
      "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
      "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430ed",
      "stepCode": "CERTIFICATE_REVIEW",
      "stepName": "Certificate review",
      "stepDescription": "Certificate review",
      "stepOrder": 5,
      "isParallel": false,
      "status": "1",
      "steps": [
        {
          "id": "fafe0409-a6e0-4a4f-bd6e-7aa7ed7c2268",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "C0F587F29CC17AE748257F33001B4901",
          "createTime": "2025-12-05T13:42:11.991+00:00",
          "updateTime": "2025-12-05T15:21:07.754+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430ee",
          "parentStepId": "b6a46ebf-13a6-4ba8-92ac-6b03504f6691",
          "nextStepId": "e3acb46b-0430-4ce9-aabf-895596dc0bc0",
          "stepCode": "CERTIFICATE_REVIEW_AUDIT_COMPLETED",
          "stepName": "Audit pack completed",
          "stepDescription": "Audit pack completed",
          "stepOrder": 1,
          "isParallel": false,
          "status": "2",
          "actions": [],
          "configs": [
            {
              "id": "cb45fee7-aa86-4723-af9c-725df4b1b0c7",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:11.993+00:00",
              "updateTime": "2025-12-05T13:42:11.993+00:00",
              "isDeleted": "0",
              "orderWorkflowStepId": "fafe0409-a6e0-4a4f-bd6e-7aa7ed7c2268",
              "configKey": "permissions",
              "configValue": "{\"Admin\":\"edit\",\"Auditor\":\"none\",\"Coordination\":\"edit\",\"Coordination Manager\":\"edit\",\"Finance\":\"readonly\",\"Quality\":\"edit\",\"Quality manager\":\"edit\",\"Sales\":\"readonly\",\"Sales Manager\":\"readonly\",\"Technical Reviewer\":\"readonly\"}",
              "configType": "JSON"
            }
          ],
          "createByName": "binesh.brcgs",
          "updateByName": "Binesh Narayanan"
        },
        {
          "id": "e3acb46b-0430-4ce9-aabf-895596dc0bc0",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "C0F587F29CC17AE748257F33001B4901",
          "createTime": "2025-12-05T13:42:11.995+00:00",
          "updateTime": "2025-12-05T15:21:07.774+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430ef",
          "parentStepId": "b6a46ebf-13a6-4ba8-92ac-6b03504f6691",
          "nextStepId": "a3ec0d85-c09d-42dc-985a-ff0b3cb9f793",
          "stepCode": "ASSIGN_TECHNICAL_REVIEWER",
          "stepName": "Technical reviewer assignment",
          "stepDescription": "Technical reviewer assignment",
          "stepOrder": 2,
          "isParallel": false,
          "status": "1",
          "actions": [
            {
              "id": "64cf8a83-d82f-4878-9ed0-7be4f62097fd",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:11.998+00:00",
              "updateTime": "2025-12-05T13:42:11.998+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "e3acb46b-0430-4ce9-aabf-895596dc0bc0",
              "workflowStepActionId": "e2f3a4b5-6c7d-8901-2345-6789012345b4",
              "actionCode": "ASSIGN_TECH_REVIEWER",
              "actionName": "Assign",
              "actionDescription": "Assign Technical Reviewer",
              "actionType": "BUTTON",
              "actionOrder": 1,
              "isRequired": true,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "994c589a-5c1b-42df-a64e-dbc0578875e8",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.001+00:00",
                  "updateTime": "2025-12-05T13:42:12.001+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "64cf8a83-d82f-4878-9ed0-7be4f62097fd",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"technicalReviewer\",\"isActionNameDynamic\":true,\"icon\":\"EDIT\",\"iconPosition\":\"right\",\"shouldDisplayActions\":true,\"displayMode\":\"user_assignment\"}",
                  "configType": "JSON"
                },
                {
                  "id": "c2212ca0-9c25-4adb-86cd-4ea9c58582f4",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.003+00:00",
                  "updateTime": "2025-12-05T13:42:12.003+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "64cf8a83-d82f-4878-9ed0-7be4f62097fd",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Assign\",\"icon\":\"EDIT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "8efb50a5-a24f-4a2d-a275-da9742081140",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.005+00:00",
                  "updateTime": "2025-12-05T13:42:12.005+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "64cf8a83-d82f-4878-9ed0-7be4f62097fd",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Assign\",\"icon\":\"ADD_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                }
              ]
            }
          ],
          "configs": [
            {
              "id": "f5cfd1d2-0a96-4039-b034-86f70f5cbf57",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:11.997+00:00",
              "updateTime": "2025-12-05T13:42:11.997+00:00",
              "isDeleted": "0",
              "orderWorkflowStepId": "e3acb46b-0430-4ce9-aabf-895596dc0bc0",
              "configKey": "permissions",
              "configValue": "{\"Admin\":\"none\",\"Auditor\":\"none\",\"Coordination\":\"none\",\"Coordination Manager\":\"none\",\"Finance\":\"none\",\"Quality\":\"none\",\"Quality manager\":\"none\",\"Sales\":\"none\",\"Sales Manager\":\"none\",\"Technical Reviewer\":\"none\"}",
              "configType": "JSON"
            }
          ],
          "createByName": "binesh.brcgs",
          "updateByName": "Binesh Narayanan"
        },
        {
          "id": "a3ec0d85-c09d-42dc-985a-ff0b3cb9f793",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
          "createTime": "2025-12-05T13:42:12.007+00:00",
          "updateTime": "2025-12-05T13:42:12.007+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430f0",
          "parentStepId": "b6a46ebf-13a6-4ba8-92ac-6b03504f6691",
          "nextStepId": "0fa5f80a-ad59-45f5-a9ab-14ca2a199aba",
          "stepCode": "AUDIT_PACK_SUBMITTED",
          "stepName": "Audit pack submitted",
          "stepDescription": "Audit pack submitted",
          "stepOrder": 3,
          "isParallel": false,
          "status": "0",
          "actions": [
            {
              "id": "91851978-2ede-4ba8-a3a8-a8bdea485b48",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:12.010+00:00",
              "updateTime": "2025-12-05T13:42:12.010+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "a3ec0d85-c09d-42dc-985a-ff0b3cb9f793",
              "workflowStepActionId": "g1h2i3j4-5k6l-7890-1234-5678901234ab",
              "actionCode": "CONFIRM_AUDIT_PACK_VERIFIED",
              "actionName": "Confirm as verified",
              "actionDescription": "Confirm that all required documents are uploaded and correct",
              "actionType": "BUTTON",
              "actionOrder": 1,
              "isRequired": true,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "da940ab5-4c5b-4e6c-a80e-2e0e28027d3f",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.012+00:00",
                  "updateTime": "2025-12-05T13:42:12.012+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "91851978-2ede-4ba8-a3a8-a8bdea485b48",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"Confirm as verified\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "12931d4e-30dc-49b8-9ee1-83d13d90493b",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.014+00:00",
                  "updateTime": "2025-12-05T13:42:12.014+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "91851978-2ede-4ba8-a3a8-a8bdea485b48",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Confirm as verified\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "9a2ae9b0-61de-4633-accd-34a85c0090e1",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.016+00:00",
                  "updateTime": "2025-12-05T13:42:12.016+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "91851978-2ede-4ba8-a3a8-a8bdea485b48",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Confirm as verified\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "eca782ba-1af0-4f0e-a56a-063cbf639494",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.018+00:00",
                  "updateTime": "2025-12-05T13:42:12.018+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "91851978-2ede-4ba8-a3a8-a8bdea485b48",
                  "configKey": "completed_state",
                  "configValue": "hide",
                  "configType": "string"
                },
                {
                  "id": "eb7b402d-04df-4e84-bf38-ae7eb62e7465",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.019+00:00",
                  "updateTime": "2025-12-05T13:42:12.019+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "91851978-2ede-4ba8-a3a8-a8bdea485b48",
                  "configKey": "pending_state",
                  "configValue": "hide",
                  "configType": "string"
                }
              ]
            }
          ],
          "configs": [
            {
              "id": "63295001-5a40-40d8-98f2-68436309eb97",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:12.009+00:00",
              "updateTime": "2025-12-05T13:42:12.009+00:00",
              "isDeleted": "0",
              "orderWorkflowStepId": "a3ec0d85-c09d-42dc-985a-ff0b3cb9f793",
              "configKey": "permissions",
              "configValue": "{\"Admin\":\"none\",\"Auditor\":\"none\",\"Coordination\":\"none\",\"Coordination Manager\":\"none\",\"Finance\":\"none\",\"Quality\":\"none\",\"Quality manager\":\"none\",\"Sales\":\"none\",\"Sales Manager\":\"none\",\"Technical Reviewer\":\"none\"}",
              "configType": "JSON"
            }
          ],
          "createByName": "binesh.brcgs",
          "updateByName": "binesh.brcgs"
        },
        {
          "id": "0fa5f80a-ad59-45f5-a9ab-14ca2a199aba",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
          "createTime": "2025-12-05T13:42:12.021+00:00",
          "updateTime": "2025-12-05T13:42:12.021+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430f1",
          "parentStepId": "b6a46ebf-13a6-4ba8-92ac-6b03504f6691",
          "nextStepId": "e7621e60-60c3-441f-a862-0c120b36a3b4",
          "stepCode": "TECHNICAL_REVIEW",
          "stepName": "Technical review",
          "stepDescription": "Technical review",
          "stepOrder": 4,
          "isParallel": false,
          "status": "0",
          "steps": [
            {
              "id": "dfa84b40-5e4f-4fc3-91fb-631c540eac51",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:12.025+00:00",
              "updateTime": "2025-12-05T13:42:12.025+00:00",
              "isDeleted": "0",
              "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
              "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430f2",
              "parentStepId": "0fa5f80a-ad59-45f5-a9ab-14ca2a199aba",
              "nextStepId": "535340b9-42a6-4cbc-9587-37ca8dcf11f0",
              "stepCode": "VALIDATE_AUDIT_PACK",
              "stepName": "Validate audit pack",
              "stepDescription": "Validate audit pack",
              "stepOrder": 1,
              "isParallel": false,
              "status": "0",
              "actions": [
                {
                  "id": "22be923e-9d10-4d7a-8792-c03efc298458",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.028+00:00",
                  "updateTime": "2025-12-05T13:42:12.028+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepStateId": "dfa84b40-5e4f-4fc3-91fb-631c540eac51",
                  "workflowStepActionId": "f3a4b5c6-7d8e-9012-3456-7890123456c5",
                  "actionCode": "VALIDATE_AUDIT_PACK",
                  "actionName": "Validate",
                  "actionDescription": "Validate",
                  "actionType": "BUTTON",
                  "actionOrder": 1,
                  "isRequired": true,
                  "isParallel": false,
                  "status": "0",
                  "configs": [
                    {
                      "id": "d7d5761b-8fd1-45f5-a421-d8e0c6ffc681",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.030+00:00",
                      "updateTime": "2025-12-05T13:42:12.030+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "22be923e-9d10-4d7a-8792-c03efc298458",
                      "configKey": "DONE",
                      "configValue": "{\"status\":\"2\",\"name\":\"Validate\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "f7bfed4b-23c9-41f4-8ae9-b1f4427388a8",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.032+00:00",
                      "updateTime": "2025-12-05T13:42:12.032+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "22be923e-9d10-4d7a-8792-c03efc298458",
                      "configKey": "IN_PROGRESS",
                      "configValue": "{\"status\":\"1\",\"name\":\"Validate\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "1c90c88c-6c0d-4ad6-aa4d-55e6b0e493ce",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.034+00:00",
                      "updateTime": "2025-12-05T13:42:12.034+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "22be923e-9d10-4d7a-8792-c03efc298458",
                      "configKey": "TODO",
                      "configValue": "{\"status\":\"0\",\"name\":\"Validate\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "a6aaff70-e83b-44d7-bc2e-24b44e82dde1",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.035+00:00",
                      "updateTime": "2025-12-05T13:42:12.035+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "22be923e-9d10-4d7a-8792-c03efc298458",
                      "configKey": "permissions",
                      "configValue": "{\"Admin\":\"none\",\"Auditor\":\"none\",\"Coordination\":\"none\",\"Coordination Manager\":\"none\",\"Finance\":\"none\",\"Quality\":\"none\",\"Quality manager\":\"none\",\"Sales\":\"none\",\"Sales Manager\":\"none\",\"Technical Reviewer\":\"none\"}",
                      "configType": "JSON"
                    }
                  ]
                }
              ],
              "configs": [],
              "createByName": "binesh.brcgs",
              "updateByName": "binesh.brcgs"
            },
            {
              "id": "535340b9-42a6-4cbc-9587-37ca8dcf11f0",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:12.037+00:00",
              "updateTime": "2025-12-05T13:42:12.037+00:00",
              "isDeleted": "0",
              "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
              "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430f3",
              "parentStepId": "0fa5f80a-ad59-45f5-a9ab-14ca2a199aba",
              "stepCode": "EVALUATE_AUDITORS",
              "stepName": "Evaluate auditors",
              "stepDescription": "Evaluate auditors",
              "stepOrder": 2,
              "isParallel": false,
              "status": "0",
              "actions": [
                {
                  "id": "678e86d8-3de2-496d-b2af-0617b2827056",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.039+00:00",
                  "updateTime": "2025-12-05T13:42:12.039+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepStateId": "535340b9-42a6-4cbc-9587-37ca8dcf11f0",
                  "workflowStepActionId": "a4b5c6d7-8e9f-0123-4567-8901234567d6",
                  "actionCode": "EVALUATE_AUDITORS",
                  "actionName": "Evaluate",
                  "actionDescription": "Evaluate",
                  "actionType": "BUTTON",
                  "actionOrder": 1,
                  "isRequired": true,
                  "isParallel": false,
                  "status": "0",
                  "configs": [
                    {
                      "id": "a4e255e4-8ece-4c5f-bede-1661fd4cea38",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.041+00:00",
                      "updateTime": "2025-12-05T13:42:12.041+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "678e86d8-3de2-496d-b2af-0617b2827056",
                      "configKey": "DONE",
                      "configValue": "{\"status\":\"2\",\"name\":\"Edit\",\"icon\":\"EDIT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "0b9eb7c7-79ce-4785-a8e0-f0f802631061",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.043+00:00",
                      "updateTime": "2025-12-05T13:42:12.043+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "678e86d8-3de2-496d-b2af-0617b2827056",
                      "configKey": "IN_PROGRESS",
                      "configValue": "{\"status\":\"1\",\"name\":\"Evaluate\",\"icon\":\"FAVORITE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "949ce704-1ef2-4ad9-af54-2c5efe58f79e",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.045+00:00",
                      "updateTime": "2025-12-05T13:42:12.045+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "678e86d8-3de2-496d-b2af-0617b2827056",
                      "configKey": "TODO",
                      "configValue": "{\"status\":\"0\",\"name\":\"Evaluate\",\"icon\":\"FAVORITE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "9f24488c-0149-429c-91f5-8d6d6d1fd0a9",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.047+00:00",
                      "updateTime": "2025-12-05T13:42:12.047+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "678e86d8-3de2-496d-b2af-0617b2827056",
                      "configKey": "permissions",
                      "configValue": "{\"Admin\":\"none\",\"Auditor\":\"none\",\"Coordination\":\"none\",\"Coordination Manager\":\"none\",\"Finance\":\"none\",\"Quality\":\"none\",\"Quality manager\":\"none\",\"Sales\":\"none\",\"Sales Manager\":\"none\",\"Technical Reviewer\":\"none\"}",
                      "configType": "JSON"
                    }
                  ]
                }
              ],
              "configs": [],
              "createByName": "binesh.brcgs",
              "updateByName": "binesh.brcgs"
            }
          ],
          "actions": [],
          "configs": [
            {
              "id": "c6ddc92a-eac5-41bd-a79f-db73e0a23c60",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:12.024+00:00",
              "updateTime": "2025-12-05T13:42:12.024+00:00",
              "isDeleted": "0",
              "orderWorkflowStepId": "0fa5f80a-ad59-45f5-a9ab-14ca2a199aba",
              "configKey": "permissions",
              "configValue": "{\"Admin\":\"none\",\"Auditor\":\"none\",\"Coordination\":\"none\",\"Coordination Manager\":\"none\",\"Finance\":\"none\",\"Quality\":\"none\",\"Quality manager\":\"none\",\"Sales\":\"none\",\"Sales Manager\":\"none\",\"Technical Reviewer\":\"edit\"}",
              "configType": "JSON"
            }
          ],
          "createByName": "binesh.brcgs",
          "updateByName": "binesh.brcgs"
        },
        {
          "id": "e7621e60-60c3-441f-a862-0c120b36a3b4",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
          "createTime": "2025-12-05T13:42:12.048+00:00",
          "updateTime": "2025-12-05T13:42:12.048+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430f4",
          "parentStepId": "b6a46ebf-13a6-4ba8-92ac-6b03504f6691",
          "nextStepId": "7008746b-8a7b-42c3-8c4d-8e74f22c6787",
          "stepCode": "UPLOAD_CPV_DOCUMENT_TECH_REVIEWER",
          "stepName": "Please upload the CPV document",
          "stepDescription": "Please upload the CPV document",
          "stepOrder": 5,
          "isParallel": false,
          "status": "0",
          "actions": [
            {
              "id": "07f83f9c-4da7-46e5-aa23-5a4f4dd430a5",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:12.052+00:00",
              "updateTime": "2025-12-05T13:42:12.052+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "e7621e60-60c3-441f-a862-0c120b36a3b4",
              "workflowStepActionId": "b5c6d7e8-9f0a-1234-5678-9012345678e7",
              "actionCode": "GO_TO_CPV_TECH_REVIEWER",
              "actionName": "Go to CPV",
              "actionDescription": "Go to CPV",
              "actionType": "BUTTON",
              "actionOrder": 1,
              "isRequired": false,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "b2ffbb8f-f7d7-453e-8c03-9ffa61fe51bf",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.054+00:00",
                  "updateTime": "2025-12-05T13:42:12.054+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "07f83f9c-4da7-46e5-aa23-5a4f4dd430a5",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"Go to CPV\",\"icon\":\"MENU\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "822cf928-2d37-4805-b044-efb4aaded0b3",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.056+00:00",
                  "updateTime": "2025-12-05T13:42:12.056+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "07f83f9c-4da7-46e5-aa23-5a4f4dd430a5",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Go to CPV\",\"icon\":\"MENU\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "9752e7b4-d422-4fea-a9ba-ffbcc80ca62f",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.058+00:00",
                  "updateTime": "2025-12-05T13:42:12.058+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "07f83f9c-4da7-46e5-aa23-5a4f4dd430a5",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Go to CPV\",\"icon\":\"MENU\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "b77cdee9-ef5f-4768-a221-6c05b5941277",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.059+00:00",
                  "updateTime": "2025-12-05T13:42:12.059+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "07f83f9c-4da7-46e5-aa23-5a4f4dd430a5",
                  "configKey": "completed_state",
                  "configValue": "hide",
                  "configType": "string"
                },
                {
                  "id": "e50d33bd-ad22-41e5-9115-4537a07d8a4a",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.061+00:00",
                  "updateTime": "2025-12-05T13:42:12.061+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "07f83f9c-4da7-46e5-aa23-5a4f4dd430a5",
                  "configKey": "pending_state",
                  "configValue": "hide",
                  "configType": "string"
                }
              ]
            },
            {
              "id": "1086ce29-9ef2-4f76-b79f-9a9d49d0830d",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:12.062+00:00",
              "updateTime": "2025-12-05T13:42:12.062+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "e7621e60-60c3-441f-a862-0c120b36a3b4",
              "workflowStepActionId": "ff24c90c-eae3-4444-afcb-b9440268dcf5",
              "actionCode": "CPV_DONE_TECH_REVIEWER",
              "actionName": "Done",
              "actionDescription": "Done",
              "actionType": "BUTTON",
              "actionOrder": 2,
              "isRequired": true,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "0de0b1ca-03a9-4d73-919b-0f148db812a0",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.066+00:00",
                  "updateTime": "2025-12-05T13:42:12.066+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "1086ce29-9ef2-4f76-b79f-9a9d49d0830d",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"Done\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "d7af4ca9-10b4-4215-a510-8ca38141232a",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.067+00:00",
                  "updateTime": "2025-12-05T13:42:12.067+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "1086ce29-9ef2-4f76-b79f-9a9d49d0830d",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Done\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "f6d7c324-d4a3-49b5-861f-51a727511b4c",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.069+00:00",
                  "updateTime": "2025-12-05T13:42:12.069+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "1086ce29-9ef2-4f76-b79f-9a9d49d0830d",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Done\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "43e610e7-608c-4c52-9ce5-332a87803392",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.071+00:00",
                  "updateTime": "2025-12-05T13:42:12.071+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "1086ce29-9ef2-4f76-b79f-9a9d49d0830d",
                  "configKey": "completed_state",
                  "configValue": "hide",
                  "configType": "string"
                },
                {
                  "id": "a150e594-ce10-4afc-9a9b-f17cb45f6f02",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.072+00:00",
                  "updateTime": "2025-12-05T13:42:12.072+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "1086ce29-9ef2-4f76-b79f-9a9d49d0830d",
                  "configKey": "pending_state",
                  "configValue": "hide",
                  "configType": "string"
                }
              ]
            }
          ],
          "configs": [
            {
              "id": "7a46d694-8645-45d2-8313-3a06471f613d",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:12.050+00:00",
              "updateTime": "2025-12-05T13:42:12.050+00:00",
              "isDeleted": "0",
              "orderWorkflowStepId": "e7621e60-60c3-441f-a862-0c120b36a3b4",
              "configKey": "permissions",
              "configValue": "{\"Admin\":\"none\",\"Auditor\":\"none\",\"Coordination\":\"none\",\"Coordination Manager\":\"none\",\"Finance\":\"none\",\"Quality\":\"none\",\"Quality manager\":\"none\",\"Sales\":\"none\",\"Sales Manager\":\"none\",\"Technical Reviewer\":\"edit\"}",
              "configType": "JSON"
            }
          ],
          "createByName": "binesh.brcgs",
          "updateByName": "binesh.brcgs"
        },
        {
          "id": "7008746b-8a7b-42c3-8c4d-8e74f22c6787",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
          "createTime": "2025-12-05T13:42:12.074+00:00",
          "updateTime": "2025-12-05T13:42:12.074+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430f5",
          "parentStepId": "b6a46ebf-13a6-4ba8-92ac-6b03504f6691",
          "nextStepId": "fed9a480-399e-447c-8c1e-0e70743fa2a1",
          "stepCode": "PROCESS_REVIEW",
          "stepName": "Process review",
          "stepDescription": "Process review",
          "stepOrder": 6,
          "isParallel": false,
          "status": "0",
          "steps": [
            {
              "id": "3e9e6dc7-0cc8-43c0-b2c4-077321003bb3",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:12.121+00:00",
              "updateTime": "2025-12-05T13:42:12.121+00:00",
              "isDeleted": "0",
              "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
              "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd43103",
              "parentStepId": "7008746b-8a7b-42c3-8c4d-8e74f22c6787",
              "stepCode": "VALIDATE_AUDIT_DATES_AND_CERTIFICATES",
              "stepName": "Validate audit dates and certificates",
              "stepDescription": "Validate audit dates and certificates",
              "stepOrder": 2,
              "isParallel": false,
              "status": "0",
              "actions": [
                {
                  "id": "fa8f5f43-2a5a-4662-94fb-48beeeca7837",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.123+00:00",
                  "updateTime": "2025-12-05T13:42:12.123+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepStateId": "3e9e6dc7-0cc8-43c0-b2c4-077321003bb3",
                  "workflowStepActionId": "h2i3j4k5-6l7m-8901-2345-6789012345bc",
                  "actionCode": "EDIT_DATES",
                  "actionName": "Edit dates",
                  "actionDescription": "Edit audit dates",
                  "actionType": "BUTTON",
                  "actionOrder": 1,
                  "isRequired": false,
                  "isParallel": false,
                  "status": "0",
                  "configs": [
                    {
                      "id": "6b2fcfe9-9025-4657-81eb-54c6b10db8b8",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.125+00:00",
                      "updateTime": "2025-12-05T13:42:12.125+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "fa8f5f43-2a5a-4662-94fb-48beeeca7837",
                      "configKey": "DONE",
                      "configValue": "{\"status\":\"2\",\"name\":\"Edit dates\",\"icon\":\"EDIT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "b3924c72-461f-40ae-b871-be368cfdb815",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.128+00:00",
                      "updateTime": "2025-12-05T13:42:12.128+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "fa8f5f43-2a5a-4662-94fb-48beeeca7837",
                      "configKey": "IN_PROGRESS",
                      "configValue": "{\"status\":\"1\",\"name\":\"Edit dates\",\"icon\":\"EDIT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "cb1093df-6be1-4ac9-83eb-2bdf4aaf2aa9",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.129+00:00",
                      "updateTime": "2025-12-05T13:42:12.129+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "fa8f5f43-2a5a-4662-94fb-48beeeca7837",
                      "configKey": "TODO",
                      "configValue": "{\"status\":\"0\",\"name\":\"Edit dates\",\"icon\":\"EDIT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "bd40e09d-7ce0-41ba-8a15-02d67d64f818",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.131+00:00",
                      "updateTime": "2025-12-05T13:42:12.131+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "fa8f5f43-2a5a-4662-94fb-48beeeca7837",
                      "configKey": "completed_state",
                      "configValue": "hide",
                      "configType": "string"
                    },
                    {
                      "id": "c9702a0c-3bb9-457e-95ba-88655029029e",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.132+00:00",
                      "updateTime": "2025-12-05T13:42:12.132+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "fa8f5f43-2a5a-4662-94fb-48beeeca7837",
                      "configKey": "pending_state",
                      "configValue": "hide",
                      "configType": "string"
                    }
                  ]
                },
                {
                  "id": "81c7fdd8-bbe8-4e4d-9508-1391ff34fd28",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.134+00:00",
                  "updateTime": "2025-12-05T13:42:12.134+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepStateId": "3e9e6dc7-0cc8-43c0-b2c4-077321003bb3",
                  "workflowStepActionId": "i3j4k5l6-7m8n-9012-3456-7890123456cd",
                  "actionCode": "VALIDATE_PROCESS_REVIEW",
                  "actionName": "Validate",
                  "actionDescription": "Validate audit dates and certificates",
                  "actionType": "BUTTON",
                  "actionOrder": 2,
                  "isRequired": true,
                  "isParallel": false,
                  "status": "0",
                  "configs": [
                    {
                      "id": "899f319c-d155-4fc9-8ab7-a492e481f40a",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.135+00:00",
                      "updateTime": "2025-12-05T13:42:12.135+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "81c7fdd8-bbe8-4e4d-9508-1391ff34fd28",
                      "configKey": "DONE",
                      "configValue": "{\"status\":\"2\",\"name\":\"Validate\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "16918fe9-b5bb-45e7-8211-79ad6c3228d3",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.137+00:00",
                      "updateTime": "2025-12-05T13:42:12.137+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "81c7fdd8-bbe8-4e4d-9508-1391ff34fd28",
                      "configKey": "IN_PROGRESS",
                      "configValue": "{\"status\":\"1\",\"name\":\"Validate\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "316f7c2e-e592-4151-aa3d-3b93c9c3b50b",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.138+00:00",
                      "updateTime": "2025-12-05T13:42:12.138+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "81c7fdd8-bbe8-4e4d-9508-1391ff34fd28",
                      "configKey": "TODO",
                      "configValue": "{\"status\":\"0\",\"name\":\"Validate\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "c48aca29-6977-4799-8151-d0b97b542f77",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.140+00:00",
                      "updateTime": "2025-12-05T13:42:12.140+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "81c7fdd8-bbe8-4e4d-9508-1391ff34fd28",
                      "configKey": "completed_state",
                      "configValue": "hide",
                      "configType": "string"
                    },
                    {
                      "id": "77d463d8-67c2-48ab-aa56-77d328bdb576",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.141+00:00",
                      "updateTime": "2025-12-05T13:42:12.141+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "81c7fdd8-bbe8-4e4d-9508-1391ff34fd28",
                      "configKey": "pending_state",
                      "configValue": "hide",
                      "configType": "string"
                    }
                  ]
                }
              ],
              "configs": [],
              "createByName": "binesh.brcgs",
              "updateByName": "binesh.brcgs"
            }
          ],
          "actions": [],
          "configs": [
            {
              "id": "682e6cc1-cf78-4382-89db-070cf70cd4d0",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:12.076+00:00",
              "updateTime": "2025-12-05T13:42:12.076+00:00",
              "isDeleted": "0",
              "orderWorkflowStepId": "7008746b-8a7b-42c3-8c4d-8e74f22c6787",
              "configKey": "permissions",
              "configValue": "{\"Admin\":\"none\",\"Auditor\":\"none\",\"Coordination\":\"none\",\"Coordination Manager\":\"none\",\"Finance\":\"none\",\"Quality\":\"none\",\"Quality manager\":\"none\",\"Sales\":\"none\",\"Sales Manager\":\"none\",\"Technical Reviewer\":\"none\"}",
              "configType": "JSON"
            }
          ],
          "createByName": "binesh.brcgs",
          "updateByName": "binesh.brcgs"
        },
        {
          "id": "fed9a480-399e-447c-8c1e-0e70743fa2a1",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
          "createTime": "2025-12-05T13:42:12.143+00:00",
          "updateTime": "2025-12-05T13:42:12.143+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430f9",
          "parentStepId": "b6a46ebf-13a6-4ba8-92ac-6b03504f6691",
          "nextStepId": "6b16fcb3-d9ba-4d67-b6ea-81a762748d55",
          "stepCode": "UPLOAD_CPV_DOCUMENT_PROCESS_REVIEWER",
          "stepName": "Please upload the CPV document",
          "stepDescription": "Please upload the CPV document",
          "stepOrder": 7,
          "isParallel": false,
          "status": "0",
          "actions": [
            {
              "id": "7ffd30a4-1406-45ac-bb0a-e483883dddbe",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:12.146+00:00",
              "updateTime": "2025-12-05T13:42:12.146+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "fed9a480-399e-447c-8c1e-0e70743fa2a1",
              "workflowStepActionId": "b1c2d3e4-5f6a-7890-1234-5678901234ed",
              "actionCode": "GO_TO_CPV_PROCESS_REVIEWER",
              "actionName": "Go to CPV",
              "actionDescription": "Go to CPV",
              "actionType": "BUTTON",
              "actionOrder": 1,
              "isRequired": false,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "082b6867-7302-4c8f-a074-967656e97d11",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.149+00:00",
                  "updateTime": "2025-12-05T13:42:12.149+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "7ffd30a4-1406-45ac-bb0a-e483883dddbe",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"Go to CPV\",\"icon\":\"MENU\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "dc4e6883-8f1f-451b-a31f-126f981da273",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.151+00:00",
                  "updateTime": "2025-12-05T13:42:12.151+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "7ffd30a4-1406-45ac-bb0a-e483883dddbe",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Go to CPV\",\"icon\":\"MENU\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "f76a7f7b-756d-4804-b327-95fad9dac434",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.153+00:00",
                  "updateTime": "2025-12-05T13:42:12.153+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "7ffd30a4-1406-45ac-bb0a-e483883dddbe",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Go to CPV\",\"icon\":\"MENU\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "b890095c-fb1d-49e8-bdc9-c78487454ba6",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.154+00:00",
                  "updateTime": "2025-12-05T13:42:12.154+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "7ffd30a4-1406-45ac-bb0a-e483883dddbe",
                  "configKey": "completed_state",
                  "configValue": "hide",
                  "configType": "string"
                },
                {
                  "id": "10b065aa-0512-42e4-b38b-7e9c9ca14d3a",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.156+00:00",
                  "updateTime": "2025-12-05T13:42:12.156+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "7ffd30a4-1406-45ac-bb0a-e483883dddbe",
                  "configKey": "pending_state",
                  "configValue": "hide",
                  "configType": "string"
                }
              ]
            },
            {
              "id": "38df6e66-86a1-4b3a-b7e2-995b6573781e",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:12.158+00:00",
              "updateTime": "2025-12-05T13:42:12.158+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "fed9a480-399e-447c-8c1e-0e70743fa2a1",
              "workflowStepActionId": "323b8a42-4a5c-4304-9633-1bf162cf253d",
              "actionCode": "CPV_DONE_PROCESS_REVIEWER",
              "actionName": "Done",
              "actionDescription": "Done",
              "actionType": "BUTTON",
              "actionOrder": 2,
              "isRequired": true,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "4853063a-f6c0-41c8-a3d1-07bcff78ab24",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.160+00:00",
                  "updateTime": "2025-12-05T13:42:12.160+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "38df6e66-86a1-4b3a-b7e2-995b6573781e",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"Done\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "3bf2e03b-a6a2-43eb-9a54-d35f568d01d6",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.162+00:00",
                  "updateTime": "2025-12-05T13:42:12.162+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "38df6e66-86a1-4b3a-b7e2-995b6573781e",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Done\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "8e884c19-e009-4744-a8e0-166a11f65eec",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.164+00:00",
                  "updateTime": "2025-12-05T13:42:12.164+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "38df6e66-86a1-4b3a-b7e2-995b6573781e",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Done\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "1a50a2ba-e924-4a6b-9184-db71fb7e1dfd",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.165+00:00",
                  "updateTime": "2025-12-05T13:42:12.165+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "38df6e66-86a1-4b3a-b7e2-995b6573781e",
                  "configKey": "completed_state",
                  "configValue": "hide",
                  "configType": "string"
                },
                {
                  "id": "e43943be-96c5-40f8-88d9-ee52d122d411",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.167+00:00",
                  "updateTime": "2025-12-05T13:42:12.167+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "38df6e66-86a1-4b3a-b7e2-995b6573781e",
                  "configKey": "pending_state",
                  "configValue": "hide",
                  "configType": "string"
                }
              ]
            }
          ],
          "configs": [
            {
              "id": "73f9e94f-273b-4c9a-a5fe-796300806d33",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:12.145+00:00",
              "updateTime": "2025-12-05T13:42:12.145+00:00",
              "isDeleted": "0",
              "orderWorkflowStepId": "fed9a480-399e-447c-8c1e-0e70743fa2a1",
              "configKey": "permissions",
              "configValue": "{\"Admin\":\"none\",\"Auditor\":\"none\",\"Coordination\":\"none\",\"Coordination Manager\":\"none\",\"Finance\":\"none\",\"Quality\":\"none\",\"Quality manager\":\"none\",\"Sales\":\"none\",\"Sales Manager\":\"none\",\"Technical Reviewer\":\"none\"}",
              "configType": "JSON"
            }
          ],
          "createByName": "binesh.brcgs",
          "updateByName": "binesh.brcgs"
        },
        {
          "id": "6b16fcb3-d9ba-4d67-b6ea-81a762748d55",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
          "createTime": "2025-12-05T13:42:12.168+00:00",
          "updateTime": "2025-12-05T13:42:12.168+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430fa",
          "parentStepId": "b6a46ebf-13a6-4ba8-92ac-6b03504f6691",
          "nextStepId": "1b52c6b2-0659-4ca5-a218-5dcd213e0409",
          "stepCode": "ASSIGN_DECISION_MAKER",
          "stepName": "Decision Maker assignment",
          "stepDescription": "Decision maker assignment",
          "stepOrder": 8,
          "isParallel": false,
          "status": "0",
          "actions": [
            {
              "id": "d3ef9ef8-f915-45fc-98fb-1245f0fc4bf4",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:12.172+00:00",
              "updateTime": "2025-12-05T13:42:12.172+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "6b16fcb3-d9ba-4d67-b6ea-81a762748d55",
              "workflowStepActionId": "c2d3e4f5-6a7b-8901-2345-6789012345fe",
              "actionCode": "ASSIGN_DECISION_MAKER",
              "actionName": "Assign",
              "actionDescription": "Assign Decision Maker",
              "actionType": "BUTTON",
              "actionOrder": 1,
              "isRequired": true,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "d4677dd7-0f13-4d64-9847-bff0cb2431bb",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.175+00:00",
                  "updateTime": "2025-12-05T13:42:12.175+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "d3ef9ef8-f915-45fc-98fb-1245f0fc4bf4",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"decisionMaker\",\"isActionNameDynamic\":true,\"icon\":\"EDIT\",\"iconPosition\":\"right\",\"shouldDisplayActions\":true,\"displayMode\":\"user_assignment\"}",
                  "configType": "JSON"
                },
                {
                  "id": "d0bead99-f7ed-4bc6-bfea-8b01d48e6973",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.176+00:00",
                  "updateTime": "2025-12-05T13:42:12.176+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "d3ef9ef8-f915-45fc-98fb-1245f0fc4bf4",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Assign\",\"icon\":\"EDIT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "887a69fd-0322-4969-8745-7f8657ee0fe7",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.178+00:00",
                  "updateTime": "2025-12-05T13:42:12.178+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "d3ef9ef8-f915-45fc-98fb-1245f0fc4bf4",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Assign\",\"icon\":\"ADD_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "e339f135-3153-450c-b999-d077c478b026",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.179+00:00",
                  "updateTime": "2025-12-05T13:42:12.179+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "d3ef9ef8-f915-45fc-98fb-1245f0fc4bf4",
                  "configKey": "assignee_role",
                  "configValue": "decision_maker",
                  "configType": "string"
                },
                {
                  "id": "d5cf6c65-cbd3-44cf-bb85-5b4990a85186",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.181+00:00",
                  "updateTime": "2025-12-05T13:42:12.181+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "d3ef9ef8-f915-45fc-98fb-1245f0fc4bf4",
                  "configKey": "completed_state",
                  "configValue": "hide",
                  "configType": "string"
                },
                {
                  "id": "a992d108-221a-49a7-941c-8b9acfdaa130",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.183+00:00",
                  "updateTime": "2025-12-05T13:42:12.183+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "d3ef9ef8-f915-45fc-98fb-1245f0fc4bf4",
                  "configKey": "pending_state",
                  "configValue": "display",
                  "configType": "string"
                }
              ]
            }
          ],
          "configs": [
            {
              "id": "37500402-70a8-4e34-8206-63b67bd9461e",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:12.170+00:00",
              "updateTime": "2025-12-05T13:42:12.170+00:00",
              "isDeleted": "0",
              "orderWorkflowStepId": "6b16fcb3-d9ba-4d67-b6ea-81a762748d55",
              "configKey": "permissions",
              "configValue": "{\"Admin\":\"none\",\"Auditor\":\"none\",\"Coordination\":\"none\",\"Coordination Manager\":\"none\",\"Finance\":\"none\",\"Quality\":\"none\",\"Quality manager\":\"none\",\"Sales\":\"none\",\"Sales Manager\":\"none\",\"Technical Reviewer\":\"none\"}",
              "configType": "JSON"
            }
          ],
          "createByName": "binesh.brcgs",
          "updateByName": "binesh.brcgs"
        },
        {
          "id": "1b52c6b2-0659-4ca5-a218-5dcd213e0409",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
          "createTime": "2025-12-05T13:42:12.185+00:00",
          "updateTime": "2025-12-05T13:42:12.185+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430fb",
          "parentStepId": "b6a46ebf-13a6-4ba8-92ac-6b03504f6691",
          "nextStepId": "951c67e0-3826-4d6e-9b73-1226bf5412ad",
          "stepCode": "CERTIFICATE_DECISION",
          "stepName": "Certificate decision",
          "stepDescription": "Certificate decision",
          "stepOrder": 9,
          "isParallel": false,
          "status": "0",
          "steps": [
            {
              "id": "53483453-5475-4553-b6f9-3877e2cf5dc1",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:12.189+00:00",
              "updateTime": "2025-12-05T13:42:12.189+00:00",
              "isDeleted": "0",
              "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
              "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430fc",
              "parentStepId": "1b52c6b2-0659-4ca5-a218-5dcd213e0409",
              "nextStepId": "b54dbd76-05a0-414c-a307-c827e2d6efa0",
              "stepCode": "CERT_REVIEW_DATES",
              "stepName": "Review dates",
              "stepDescription": "Review dates",
              "stepOrder": 1,
              "isParallel": false,
              "status": "0",
              "actions": [
                {
                  "id": "6f9b9d15-ccc8-4415-b1ae-c0a4aa655fe7",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.190+00:00",
                  "updateTime": "2025-12-05T13:42:12.190+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepStateId": "53483453-5475-4553-b6f9-3877e2cf5dc1",
                  "workflowStepActionId": "d3e4f5a6-7b8c-9012-3456-7890123456af",
                  "actionCode": "CERT_REVIEW_DATES_EDIT",
                  "actionName": "Edit",
                  "actionDescription": "Edit certification dates",
                  "actionType": "BUTTON",
                  "actionOrder": 1,
                  "isRequired": true,
                  "isParallel": false,
                  "status": "0",
                  "configs": [
                    {
                      "id": "06ae61d1-d338-44dc-aee2-927dae7e94c0",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.192+00:00",
                      "updateTime": "2025-12-05T13:42:12.192+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "6f9b9d15-ccc8-4415-b1ae-c0a4aa655fe7",
                      "configKey": "DONE",
                      "configValue": "{\"status\":\"2\",\"name\":\"Edit\",\"icon\":\"EDIT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "8b331ba8-eeab-4264-baaf-1e17bd6a8071",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.194+00:00",
                      "updateTime": "2025-12-05T13:42:12.194+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "6f9b9d15-ccc8-4415-b1ae-c0a4aa655fe7",
                      "configKey": "IN_PROGRESS",
                      "configValue": "{\"status\":\"1\",\"name\":\"Edit\",\"icon\":\"EDIT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "863daf8a-0dc8-4e48-9945-90bb5cdb0396",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.195+00:00",
                      "updateTime": "2025-12-05T13:42:12.195+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "6f9b9d15-ccc8-4415-b1ae-c0a4aa655fe7",
                      "configKey": "TODO",
                      "configValue": "{\"status\":\"0\",\"name\":\"Edit\",\"icon\":\"EDIT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "58e15edd-f7d0-45b3-a232-09b5c3e6bd54",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.197+00:00",
                      "updateTime": "2025-12-05T13:42:12.197+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "6f9b9d15-ccc8-4415-b1ae-c0a4aa655fe7",
                      "configKey": "completed_state",
                      "configValue": "hide",
                      "configType": "string"
                    },
                    {
                      "id": "b79c5786-951e-44f0-84da-d1d0032c9a93",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.198+00:00",
                      "updateTime": "2025-12-05T13:42:12.198+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "6f9b9d15-ccc8-4415-b1ae-c0a4aa655fe7",
                      "configKey": "on_click",
                      "configValue": "open_certificate_review_modal",
                      "configType": "string"
                    },
                    {
                      "id": "db74a91a-db73-4c26-a175-941af06301a4",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.200+00:00",
                      "updateTime": "2025-12-05T13:42:12.200+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "6f9b9d15-ccc8-4415-b1ae-c0a4aa655fe7",
                      "configKey": "pending_state",
                      "configValue": "display",
                      "configType": "string"
                    }
                  ]
                },
                {
                  "id": "b0c3f783-5eea-41ae-adad-6126b060b9ff",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.202+00:00",
                  "updateTime": "2025-12-05T13:42:12.202+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepStateId": "53483453-5475-4553-b6f9-3877e2cf5dc1",
                  "workflowStepActionId": "e4f5a6b7-8c9d-0123-4567-8901234567b0",
                  "actionCode": "CERT_REVIEW_DATES_VALIDATE",
                  "actionName": "Validate",
                  "actionDescription": "Make the final certificate decision",
                  "actionType": "BUTTON",
                  "actionOrder": 2,
                  "isRequired": true,
                  "isParallel": false,
                  "status": "0",
                  "configs": [
                    {
                      "id": "3839e6e0-4626-4911-af7e-227b7c1b5c86",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.204+00:00",
                      "updateTime": "2025-12-05T13:42:12.204+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "b0c3f783-5eea-41ae-adad-6126b060b9ff",
                      "configKey": "DONE",
                      "configValue": "{\"status\":\"2\",\"name\":\"Validate\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "46ffa257-caaa-4e69-9c13-b5bacee8ae0e",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.206+00:00",
                      "updateTime": "2025-12-05T13:42:12.206+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "b0c3f783-5eea-41ae-adad-6126b060b9ff",
                      "configKey": "IN_PROGRESS",
                      "configValue": "{\"status\":\"1\",\"name\":\"Validate\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "e4ddc417-b4a7-4d57-92ca-311ce3b80154",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.208+00:00",
                      "updateTime": "2025-12-05T13:42:12.208+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "b0c3f783-5eea-41ae-adad-6126b060b9ff",
                      "configKey": "TODO",
                      "configValue": "{\"status\":\"0\",\"name\":\"Validate\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "fee5eede-5ddc-4180-ab76-21a74ce21c9a",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.209+00:00",
                      "updateTime": "2025-12-05T13:42:12.209+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "b0c3f783-5eea-41ae-adad-6126b060b9ff",
                      "configKey": "completed_state",
                      "configValue": "hide",
                      "configType": "string"
                    },
                    {
                      "id": "51b01868-6d80-4758-910e-7407adc4a955",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.212+00:00",
                      "updateTime": "2025-12-05T13:42:12.212+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "b0c3f783-5eea-41ae-adad-6126b060b9ff",
                      "configKey": "on_click",
                      "configValue": "execute_validate",
                      "configType": "string"
                    },
                    {
                      "id": "b3fc129f-f5e8-4ec8-afca-def22b7ec363",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.213+00:00",
                      "updateTime": "2025-12-05T13:42:12.213+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "b0c3f783-5eea-41ae-adad-6126b060b9ff",
                      "configKey": "pending_state",
                      "configValue": "display",
                      "configType": "string"
                    }
                  ]
                }
              ],
              "configs": [],
              "createByName": "binesh.brcgs",
              "updateByName": "binesh.brcgs"
            },
            {
              "id": "b54dbd76-05a0-414c-a307-c827e2d6efa0",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:12.241+00:00",
              "updateTime": "2025-12-05T13:42:12.241+00:00",
              "isDeleted": "0",
              "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
              "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430fe",
              "parentStepId": "1b52c6b2-0659-4ca5-a218-5dcd213e0409",
              "nextStepId": "969a5009-b923-4087-b4c6-ad311b513f25",
              "stepCode": "MAKE_DECISION_CERTIFICATE",
              "stepName": "Make a decision about the certificate",
              "stepDescription": "Make a decision about the certificate",
              "stepOrder": 3,
              "isParallel": false,
              "status": "0",
              "actions": [
                {
                  "id": "a7a1fccb-2b58-4745-8868-7b2af5c25967",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.242+00:00",
                  "updateTime": "2025-12-05T13:42:12.242+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepStateId": "b54dbd76-05a0-414c-a307-c827e2d6efa0",
                  "workflowStepActionId": "c8d9e0f1-2a3b-4567-8901-2345678901f4",
                  "actionCode": "MAKE_CERTIFICATE_DECISION",
                  "actionName": "Make Decision",
                  "actionDescription": "Make the final certificate decision",
                  "actionType": "BUTTON",
                  "actionOrder": 1,
                  "isRequired": true,
                  "isParallel": false,
                  "status": "0",
                  "configs": [
                    {
                      "id": "1d29a5f9-d362-496c-958a-d1425704c577",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.245+00:00",
                      "updateTime": "2025-12-05T13:42:12.245+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "a7a1fccb-2b58-4745-8868-7b2af5c25967",
                      "configKey": "DONE",
                      "configValue": "{\"status\":\"2\",\"name\":\"Edit\",\"icon\":\"EDIT\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "c2fb4c62-5693-4134-884d-4743a747d381",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.246+00:00",
                      "updateTime": "2025-12-05T13:42:12.246+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "a7a1fccb-2b58-4745-8868-7b2af5c25967",
                      "configKey": "IN_PROGRESS",
                      "configValue": "{\"status\":\"1\",\"name\":\"Make Decision\",\"icon\":\"YES_NO\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "718a8ab4-3320-4b3d-85a0-d877d1c566e7",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.248+00:00",
                      "updateTime": "2025-12-05T13:42:12.248+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "a7a1fccb-2b58-4745-8868-7b2af5c25967",
                      "configKey": "TODO",
                      "configValue": "{\"status\":\"0\",\"name\":\"Make Decision\",\"icon\":\"YES_NO\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "75a5459c-4903-438f-bdf5-d9d9917df815",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.250+00:00",
                      "updateTime": "2025-12-05T13:42:12.250+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "a7a1fccb-2b58-4745-8868-7b2af5c25967",
                      "configKey": "completed_state",
                      "configValue": "hide",
                      "configType": "string"
                    },
                    {
                      "id": "d84b5414-c78d-4113-bc4f-cce7a77546ee",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.252+00:00",
                      "updateTime": "2025-12-05T13:42:12.252+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "a7a1fccb-2b58-4745-8868-7b2af5c25967",
                      "configKey": "on_click",
                      "configValue": "open_certificate_decision_modal",
                      "configType": "string"
                    },
                    {
                      "id": "96342f57-d3ed-4e01-8f01-dedc40482a68",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.253+00:00",
                      "updateTime": "2025-12-05T13:42:12.253+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "a7a1fccb-2b58-4745-8868-7b2af5c25967",
                      "configKey": "pending_state",
                      "configValue": "display",
                      "configType": "string"
                    }
                  ]
                }
              ],
              "configs": [],
              "createByName": "binesh.brcgs",
              "updateByName": "binesh.brcgs"
            },
            {
              "id": "969a5009-b923-4087-b4c6-ad311b513f25",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:12.255+00:00",
              "updateTime": "2025-12-05T13:42:12.255+00:00",
              "isDeleted": "0",
              "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
              "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd430ff",
              "parentStepId": "1b52c6b2-0659-4ca5-a218-5dcd213e0409",
              "stepCode": "CERT_REVIEW_AND_SIGN_CERTIFICATE",
              "stepName": "Review and sign the certificates",
              "stepDescription": "Review and sign the certificates",
              "stepOrder": 4,
              "isParallel": false,
              "status": "0",
              "actions": [
                {
                  "id": "3a764877-c30a-47b0-ab6c-b74771336f50",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.257+00:00",
                  "updateTime": "2025-12-05T13:42:12.257+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepStateId": "969a5009-b923-4087-b4c6-ad311b513f25",
                  "workflowStepActionId": "d9e0f1a2-3b4c-5678-9012-3456789012a5",
                  "actionCode": "SIGN_AND_CONFIRM_DECISION",
                  "actionName": "Confirm",
                  "actionDescription": "Confirm",
                  "actionType": "BUTTON",
                  "actionOrder": 1,
                  "isRequired": true,
                  "isParallel": false,
                  "status": "0",
                  "configs": [
                    {
                      "id": "4b75cff9-c326-49de-99da-cb3fdab92b8c",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.259+00:00",
                      "updateTime": "2025-12-05T13:42:12.259+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "3a764877-c30a-47b0-ab6c-b74771336f50",
                      "configKey": "DONE",
                      "configValue": "{\"status\":\"2\",\"name\":\"Confirm\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "625ca551-b480-4ff7-b8d7-c3e4472297e7",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.261+00:00",
                      "updateTime": "2025-12-05T13:42:12.261+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "3a764877-c30a-47b0-ab6c-b74771336f50",
                      "configKey": "IN_PROGRESS",
                      "configValue": "{\"status\":\"1\",\"name\":\"Confirm\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "e7d4924e-ed59-4daa-ae51-91908e229c37",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.263+00:00",
                      "updateTime": "2025-12-05T13:42:12.263+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "3a764877-c30a-47b0-ab6c-b74771336f50",
                      "configKey": "TODO",
                      "configValue": "{\"status\":\"0\",\"name\":\"Confirm\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                      "configType": "JSON"
                    },
                    {
                      "id": "e125027c-f2a8-4b7a-820e-d561fd083b22",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.265+00:00",
                      "updateTime": "2025-12-05T13:42:12.265+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "3a764877-c30a-47b0-ab6c-b74771336f50",
                      "configKey": "completed_state",
                      "configValue": "hide",
                      "configType": "string"
                    },
                    {
                      "id": "e988adca-586e-4da9-bbf2-1c93fb2407a1",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.266+00:00",
                      "updateTime": "2025-12-05T13:42:12.266+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "3a764877-c30a-47b0-ab6c-b74771336f50",
                      "configKey": "on_click",
                      "configValue": "execute_sign_and_confirm",
                      "configType": "string"
                    },
                    {
                      "id": "7461ad83-e859-4286-a1fe-84f54aeb5081",
                      "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                      "createTime": "2025-12-05T13:42:12.268+00:00",
                      "updateTime": "2025-12-05T13:42:12.268+00:00",
                      "isDeleted": "0",
                      "orderWorkflowStepActionId": "3a764877-c30a-47b0-ab6c-b74771336f50",
                      "configKey": "pending_state",
                      "configValue": "display",
                      "configType": "string"
                    }
                  ]
                }
              ],
              "configs": [],
              "createByName": "binesh.brcgs",
              "updateByName": "binesh.brcgs"
            }
          ],
          "actions": [],
          "configs": [
            {
              "id": "0bdfbf1e-8010-45bf-b502-ed617c0b1d91",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:12.187+00:00",
              "updateTime": "2025-12-05T13:42:12.187+00:00",
              "isDeleted": "0",
              "orderWorkflowStepId": "1b52c6b2-0659-4ca5-a218-5dcd213e0409",
              "configKey": "permissions",
              "configValue": "{\"Admin\":\"none\",\"Auditor\":\"none\",\"Coordination\":\"none\",\"Coordination Manager\":\"none\",\"Finance\":\"none\",\"Quality\":\"none\",\"Quality manager\":\"none\",\"Sales\":\"none\",\"Sales Manager\":\"none\",\"Technical Reviewer\":\"none\"}",
              "configType": "JSON"
            }
          ],
          "createByName": "binesh.brcgs",
          "updateByName": "binesh.brcgs"
        },
        {
          "id": "951c67e0-3826-4d6e-9b73-1226bf5412ad",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
          "createTime": "2025-12-05T13:42:12.270+00:00",
          "updateTime": "2025-12-05T13:42:12.270+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd43100",
          "parentStepId": "b6a46ebf-13a6-4ba8-92ac-6b03504f6691",
          "nextStepId": "c54d8979-d6b9-4251-98be-9063d1a182b1",
          "stepCode": "UPLOAD_CPV_DOCUMENT_DECISION_MAKER",
          "stepName": "Please upload the CPV document",
          "stepDescription": "Please upload the CPV document",
          "stepOrder": 10,
          "isParallel": false,
          "status": "0",
          "actions": [
            {
              "id": "40d6e41f-5b8e-4f61-91a5-0e7ab64b596b",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:12.274+00:00",
              "updateTime": "2025-12-05T13:42:12.274+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "951c67e0-3826-4d6e-9b73-1226bf5412ad",
              "workflowStepActionId": "e0f1a2b3-4c5d-6789-0123-4567890123b6",
              "actionCode": "GO_TO_CPV_DECISION_MAKER",
              "actionName": "Go to CPV",
              "actionDescription": "Go to CPV",
              "actionType": "BUTTON",
              "actionOrder": 1,
              "isRequired": false,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "8f0fb082-20ee-467d-8349-78bb3385d6b3",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.276+00:00",
                  "updateTime": "2025-12-05T13:42:12.276+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "40d6e41f-5b8e-4f61-91a5-0e7ab64b596b",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"Go to CPV\",\"icon\":\"MENU\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "0df0454f-9956-40ad-8ea1-424f7705fbaf",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.278+00:00",
                  "updateTime": "2025-12-05T13:42:12.278+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "40d6e41f-5b8e-4f61-91a5-0e7ab64b596b",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Go to CPV\",\"icon\":\"MENU\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "cbda20b7-519b-48e3-9257-286a8196b0a9",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.280+00:00",
                  "updateTime": "2025-12-05T13:42:12.280+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "40d6e41f-5b8e-4f61-91a5-0e7ab64b596b",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Go to CPV\",\"icon\":\"MENU\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "a42c9f83-bc99-4868-8db3-143f9f9fc059",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.281+00:00",
                  "updateTime": "2025-12-05T13:42:12.281+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "40d6e41f-5b8e-4f61-91a5-0e7ab64b596b",
                  "configKey": "completed_state",
                  "configValue": "hide",
                  "configType": "string"
                },
                {
                  "id": "78f1252b-a67c-4769-ac2a-00e00406a707",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.283+00:00",
                  "updateTime": "2025-12-05T13:42:12.283+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "40d6e41f-5b8e-4f61-91a5-0e7ab64b596b",
                  "configKey": "pending_state",
                  "configValue": "hide",
                  "configType": "string"
                }
              ]
            },
            {
              "id": "636dbf22-52d6-4a2c-a17e-044a695574c7",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:12.284+00:00",
              "updateTime": "2025-12-05T13:42:12.284+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "951c67e0-3826-4d6e-9b73-1226bf5412ad",
              "workflowStepActionId": "96399623-fb39-4aa8-bccb-e195167eb051",
              "actionCode": "CPV_DONE_DECISION_MAKER",
              "actionName": "Done",
              "actionDescription": "Done",
              "actionType": "BUTTON",
              "actionOrder": 2,
              "isRequired": true,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "c3124061-af69-4234-8f2f-0b3d98889c8e",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.286+00:00",
                  "updateTime": "2025-12-05T13:42:12.286+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "636dbf22-52d6-4a2c-a17e-044a695574c7",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"Done\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "b41a1c36-8b1e-4816-bcc0-699f49f2d177",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.288+00:00",
                  "updateTime": "2025-12-05T13:42:12.288+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "636dbf22-52d6-4a2c-a17e-044a695574c7",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Done\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "8445fe03-e36e-4ce0-be05-5480d67d2a89",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.289+00:00",
                  "updateTime": "2025-12-05T13:42:12.289+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "636dbf22-52d6-4a2c-a17e-044a695574c7",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Done\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "7bc23a4a-dd62-4b32-bc4b-a6b8e267156a",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.291+00:00",
                  "updateTime": "2025-12-05T13:42:12.291+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "636dbf22-52d6-4a2c-a17e-044a695574c7",
                  "configKey": "completed_state",
                  "configValue": "hide",
                  "configType": "string"
                },
                {
                  "id": "2445ab57-36cd-4797-8cbb-1e167b230d7b",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.292+00:00",
                  "updateTime": "2025-12-05T13:42:12.292+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "636dbf22-52d6-4a2c-a17e-044a695574c7",
                  "configKey": "pending_state",
                  "configValue": "hide",
                  "configType": "string"
                }
              ]
            }
          ],
          "configs": [
            {
              "id": "4585ba15-a4f1-463e-ab14-84f7d054cdfe",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:12.272+00:00",
              "updateTime": "2025-12-05T13:42:12.272+00:00",
              "isDeleted": "0",
              "orderWorkflowStepId": "951c67e0-3826-4d6e-9b73-1226bf5412ad",
              "configKey": "permissions",
              "configValue": "{\"Admin\":\"none\",\"Auditor\":\"none\",\"Coordination\":\"none\",\"Coordination Manager\":\"none\",\"Finance\":\"none\",\"Quality\":\"none\",\"Quality manager\":\"none\",\"Sales\":\"none\",\"Sales Manager\":\"none\",\"Technical Reviewer\":\"none\"}",
              "configType": "JSON"
            }
          ],
          "createByName": "binesh.brcgs",
          "updateByName": "binesh.brcgs"
        },
        {
          "id": "c54d8979-d6b9-4251-98be-9063d1a182b1",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
          "createTime": "2025-12-05T13:42:12.294+00:00",
          "updateTime": "2025-12-05T13:42:12.294+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd43101",
          "parentStepId": "b6a46ebf-13a6-4ba8-92ac-6b03504f6691",
          "nextStepId": "f154ac3a-55c0-4b73-a319-e8d884d1e1f4",
          "stepCode": "UPLOAD_CERTIFICATES_TO_SCHEME_DIRECTORY",
          "stepName": "Please upload certificates on the BRCGS Directory",
          "stepDescription": "Please upload certificates on the BRCGS Directory",
          "stepOrder": 11,
          "isParallel": false,
          "status": "0",
          "actions": [
            {
              "id": "fcbb5669-38d4-4364-87c2-fe95d6797f7c",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:12.297+00:00",
              "updateTime": "2025-12-05T13:42:12.297+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "c54d8979-d6b9-4251-98be-9063d1a182b1",
              "workflowStepActionId": "f1a2b3c4-5d6e-7890-1234-5678901234c7",
              "actionCode": "COMPLETED_UPLOAD_TO_SCHEME_DIRECTORY",
              "actionName": "Done",
              "actionDescription": "Done",
              "actionType": "BUTTON",
              "actionOrder": 1,
              "isRequired": true,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "7c1f7efc-4108-4c1f-aab6-59787ef7a7d7",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.299+00:00",
                  "updateTime": "2025-12-05T13:42:12.299+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "fcbb5669-38d4-4364-87c2-fe95d6797f7c",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"Done\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "e39b2743-9713-40f8-8c8f-0ba1822fc379",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.301+00:00",
                  "updateTime": "2025-12-05T13:42:12.301+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "fcbb5669-38d4-4364-87c2-fe95d6797f7c",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Done\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "12e01e66-69a6-43b6-b134-61b0c4d13a66",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.302+00:00",
                  "updateTime": "2025-12-05T13:42:12.302+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "fcbb5669-38d4-4364-87c2-fe95d6797f7c",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Done\",\"icon\":\"TICK_CIRCLE\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                }
              ]
            }
          ],
          "configs": [
            {
              "id": "4acffa8f-260a-421a-b208-0d2ec0771251",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:12.295+00:00",
              "updateTime": "2025-12-05T13:42:12.295+00:00",
              "isDeleted": "0",
              "orderWorkflowStepId": "c54d8979-d6b9-4251-98be-9063d1a182b1",
              "configKey": "permissions",
              "configValue": "{\"Admin\":\"none\",\"Auditor\":\"none\",\"Coordination\":\"none\",\"Coordination Manager\":\"none\",\"Finance\":\"none\",\"Quality\":\"none\",\"Quality manager\":\"none\",\"Sales\":\"none\",\"Sales Manager\":\"none\",\"Technical Reviewer\":\"none\"}",
              "configType": "JSON"
            }
          ],
          "createByName": "binesh.brcgs",
          "updateByName": "binesh.brcgs"
        },
        {
          "id": "f154ac3a-55c0-4b73-a319-e8d884d1e1f4",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
          "createTime": "2025-12-05T13:42:12.304+00:00",
          "updateTime": "2025-12-05T13:42:12.304+00:00",
          "isDeleted": "0",
          "orderWorkflowId": "c121aee5-896c-4b5d-ae2a-17d95a1ff977",
          "workflowStepTemplateId": "6ba7b810-9dad-11d1-80b4-00c04fd43102",
          "parentStepId": "b6a46ebf-13a6-4ba8-92ac-6b03504f6691",
          "stepCode": "SEND_NOTIFICATION_CLIENT",
          "stepName": "Client notification",
          "stepDescription": "Client notification",
          "stepOrder": 12,
          "isParallel": false,
          "status": "0",
          "actions": [
            {
              "id": "bf2a9199-4b91-4e48-98a0-b2d6839b3d8c",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:12.307+00:00",
              "updateTime": "2025-12-05T13:42:12.307+00:00",
              "isDeleted": "0",
              "orderWorkflowStepStateId": "f154ac3a-55c0-4b73-a319-e8d884d1e1f4",
              "workflowStepActionId": "a2b3c4d5-6e7f-8901-2345-6789012345d8",
              "actionCode": "SEND_CLIENT_NOTIFICATION",
              "actionName": "Send",
              "actionDescription": "Send notification to client about certificate decision",
              "actionType": "BUTTON",
              "actionOrder": 1,
              "isRequired": true,
              "isParallel": false,
              "status": "0",
              "configs": [
                {
                  "id": "e1fb1a73-a592-4fb3-a313-0e62ecbf17f8",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.310+00:00",
                  "updateTime": "2025-12-05T13:42:12.310+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "bf2a9199-4b91-4e48-98a0-b2d6839b3d8c",
                  "configKey": "DONE",
                  "configValue": "{\"status\":\"2\",\"name\":\"Send\",\"icon\":\"EMAIL\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "31b14e3f-eb39-4151-be95-bae3a5bc0605",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.311+00:00",
                  "updateTime": "2025-12-05T13:42:12.311+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "bf2a9199-4b91-4e48-98a0-b2d6839b3d8c",
                  "configKey": "IN_PROGRESS",
                  "configValue": "{\"status\":\"1\",\"name\":\"Send\",\"icon\":\"EMAIL\",\"iconPosition\":\"left\",\"shouldDisplayActions\":true,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "e03c44df-ccc3-4993-ada4-dd844ff3ee42",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.313+00:00",
                  "updateTime": "2025-12-05T13:42:12.313+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "bf2a9199-4b91-4e48-98a0-b2d6839b3d8c",
                  "configKey": "TODO",
                  "configValue": "{\"status\":\"0\",\"name\":\"Send\",\"icon\":\"EMAIL\",\"iconPosition\":\"left\",\"shouldDisplayActions\":false,\"displayMode\":\"default\",\"isActionNameDynamic\":false}",
                  "configType": "JSON"
                },
                {
                  "id": "a6effd9b-fb8c-4d57-bbd0-1466583cbdc6",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.315+00:00",
                  "updateTime": "2025-12-05T13:42:12.315+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "bf2a9199-4b91-4e48-98a0-b2d6839b3d8c",
                  "configKey": "completed_state",
                  "configValue": "hide",
                  "configType": "string"
                },
                {
                  "id": "00107932-1f06-4e98-8055-92abf6e087a3",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.316+00:00",
                  "updateTime": "2025-12-05T13:42:12.316+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "bf2a9199-4b91-4e48-98a0-b2d6839b3d8c",
                  "configKey": "email_template",
                  "configValue": "certificate_decision_notification",
                  "configType": "string"
                },
                {
                  "id": "bb04ef6c-41f8-4588-a615-f9bf8a1388be",
                  "createBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
                  "createTime": "2025-12-05T13:42:12.318+00:00",
                  "updateTime": "2025-12-05T13:42:12.318+00:00",
                  "isDeleted": "0",
                  "orderWorkflowStepActionId": "bf2a9199-4b91-4e48-98a0-b2d6839b3d8c",
                  "configKey": "pending_state",
                  "configValue": "display",
                  "configType": "string"
                }
              ]
            }
          ],
          "configs": [
            {
              "id": "65e71226-4b48-4781-98cb-4420d494c5cf",
              "createBy": "077CE8679C8D4CD68C695DDA52435F31",
              "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
              "createTime": "2025-12-05T13:42:12.306+00:00",
              "updateTime": "2025-12-05T13:42:12.306+00:00",
              "isDeleted": "0",
              "orderWorkflowStepId": "f154ac3a-55c0-4b73-a319-e8d884d1e1f4",
              "configKey": "permissions",
              "configValue": "{\"Admin\":\"none\",\"Auditor\":\"none\",\"Coordination\":\"none\",\"Coordination Manager\":\"none\",\"Finance\":\"none\",\"Quality\":\"none\",\"Quality manager\":\"none\",\"Sales\":\"none\",\"Sales Manager\":\"none\",\"Technical Reviewer\":\"none\"}",
              "configType": "JSON"
            }
          ],
          "createByName": "binesh.brcgs",
          "updateByName": "binesh.brcgs"
        }
      ],
      "actions": [],
      "configs": [
        {
          "id": "aa92b85e-8053-4b82-be47-64ed3cb28656",
          "createBy": "077CE8679C8D4CD68C695DDA52435F31",
          "updateBy": "077CE8679C8D4CD68C695DDA52435F31",
          "createTime": "2025-12-05T13:42:11.989+00:00",
          "updateTime": "2025-12-05T13:42:11.989+00:00",
          "isDeleted": "0",
          "orderWorkflowStepId": "b6a46ebf-13a6-4ba8-92ac-6b03504f6691",
          "configKey": "permissions",
          "configValue": "{\"Admin\":\"edit\",\"Auditor\":\"none\",\"Coordination\":\"edit\",\"Coordination Manager\":\"edit\",\"Finance\":\"readonly\",\"Quality\":\"edit\",\"Quality manager\":\"edit\",\"Sales\":\"readonly\",\"Sales Manager\":\"readonly\",\"Technical Reviewer\":\"readonly\"}",
          "configType": "JSON"
        }
      ]
    }
  ]
}
